'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mosaic = require('@stoplight/mosaic');
var reactErrorBoundary = require('@stoplight/react-error-boundary');
var jsonSchemaTree = require('@tarslib/json-schema-tree');
var classNames = require('classnames');
var jotai = require('jotai');
var React = require('react');
var reactIntl = require('react-intl');
var utils = require('jotai/utils');
var Radio = require('foxui/lib/radio');
var last = require('lodash/last.js');
var fnv = require('fnv-plus');
var json = require('@stoplight/json');
var Tooltip = require('foxui/lib/tooltip');
var upperFirst$1 = require('lodash/upperFirst');
var upperFirst = require('lodash/upperFirst.js');
var capitalize = require('lodash/capitalize.js');
var forIn = require('lodash/forIn');
var isEmpty = require('lodash/isEmpty');
var keys = require('lodash/keys.js');
var omit = require('lodash/omit.js');
var pick = require('lodash/pick.js');
require('lodash/uniq.js');
var isString = require('lodash/isString');
var ReactDOM = require('react-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Radio__default = /*#__PURE__*/_interopDefaultLegacy(Radio);
var last__default = /*#__PURE__*/_interopDefaultLegacy(last);
var fnv__namespace = /*#__PURE__*/_interopNamespace(fnv);
var Tooltip__default = /*#__PURE__*/_interopDefaultLegacy(Tooltip);
var upperFirst__default$1 = /*#__PURE__*/_interopDefaultLegacy(upperFirst$1);
var upperFirst__default = /*#__PURE__*/_interopDefaultLegacy(upperFirst);
var capitalize__default = /*#__PURE__*/_interopDefaultLegacy(capitalize);
var forIn__default = /*#__PURE__*/_interopDefaultLegacy(forIn);
var isEmpty__default = /*#__PURE__*/_interopDefaultLegacy(isEmpty);
var keys__default = /*#__PURE__*/_interopDefaultLegacy(keys);
var omit__default = /*#__PURE__*/_interopDefaultLegacy(omit);
var pick__default = /*#__PURE__*/_interopDefaultLegacy(pick);
var isString__default = /*#__PURE__*/_interopDefaultLegacy(isString);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

({
    [jsonSchemaTree.SchemaCombinerName.AllOf]: 'and',
    [jsonSchemaTree.SchemaCombinerName.AnyOf]: 'and/or',
    [jsonSchemaTree.SchemaCombinerName.OneOf]: 'or',
});
const COMMON_JSON_SCHEMA_AND_OAS_FORMATS = {
    number: ['byte', 'int32', 'int64', 'float', 'double', 'float32', 'float64'],
    get integer() {
        return [
            'int32',
            'int64',
            'long',
            'uint32',
            'uint64',
            'uint',
            'ulong',
            'sint32',
            'sint64',
            'fixed32',
            'fixed64',
            'sfixed32',
            'sfixed64',
            'bignum',
            'fixnum',
        ];
    },
};
const NESTING_OFFSET = 3;
const COMBINER_NAME_MAP = {
    allOf: 'all of',
    anyOf: 'any of',
    oneOf: 'one of',
};
const ADDITIONAL_PROPERTIES_KEY = '5FFA8DB1A4F0B7A88BE03034520E20FC';

var JsonSchemaDisplayMode;
(function (JsonSchemaDisplayMode) {
    JsonSchemaDisplayMode["modern"] = "MODERN";
    JsonSchemaDisplayMode["classic"] = "CLASSIC";
})(JsonSchemaDisplayMode || (JsonSchemaDisplayMode = {}));
const JSVOptionsContext = React__namespace.createContext({
    defaultExpandedDepth: 0,
    viewMode: 'standalone',
    hideExamples: false,
    displayMode: JsonSchemaDisplayMode.modern,
    appNameLower: '',
});
const useJSVOptionsContext = () => React__namespace.useContext(JSVOptionsContext);
const JSVOptionsContextProvider = JSVOptionsContext.Provider;

var en = {
    default: 'Default',
    pattern: 'Match pattern',
    example: 'Example{plural}',
    enum: 'Allowed value{plural}',
    multipleOf: 'Multiple of',
    characters: 'characters',
    required: 'required',
    deprecated: 'deprecated',
    readOnly: 'read-only',
    writeOnly: 'write-only',
    showAll: 'Show all',
    anyOf: 'anyOf, must be valid against any of the subschemas',
    oneOf: 'oneOf, must be valid against exactly one of the subschemas',
    allOf: 'allOf, must be valid against all of the subschemas',
    optional: 'optional',
    const: 'fixed value',
    parameterName: 'Name',
    parameterType: 'Type',
    parameterRequired: 'Required',
    parameterDescription: 'Description',
    none: 'None',
    additionalPropertiesKey: 'Additional properties',
};

var ja = {
    default: 'デフォルト値',
    pattern: '正規マッチ',
    example: 'サンプル値',
    enum: '列挙型',
    multipleOf: '倍数',
    characters: '文字列',
    required: '必須',
    deprecated: '廃止済み',
    readOnly: 'read-only',
    writeOnly: 'write-only',
    showAll: 'Show all',
    anyOf: 'anyOfは、サブスキーマのいずれかに対して有効でなければなりません',
    oneOf: 'oneOfは、サブスキーマのうち正確に1つに対して有効である必要があります',
    allOf: 'allOfは、すべてのサブスキーマに対して有効でなければなりません',
    optional: '可選',
    const: '固定値',
    parameterName: 'パラメータ名',
    parameterType: 'データ型',
    parameterRequired: '必須',
    parameterDescription: '説明',
    none: 'なし',
    additionalPropertiesKey: '追加パロパティ',
};

var pt = {
    default: 'Padrão',
    pattern: 'Padrão de Combinação',
    example: 'Exemplo',
    enum: 'Valores Permitidos',
    multipleOf: 'Múltiplo de',
    characters: 'Caracteres',
    required: 'requerido',
    deprecated: 'deprecated',
    readOnly: 'read-only',
    writeOnly: 'write-only',
    showAll: 'Show all',
    anyOf: 'anyOf, apenas uma das subesquemas é válida',
    oneOf: 'oneOf, deve ser válido contra exatamente uma das subesquemas',
    allOf: 'allOf, deve ser válido contra todas as subesquemas',
    optional: 'opcional',
    const: 'Valor Fixo',
    parameterName: 'Name',
    parameterType: 'Type',
    parameterRequired: 'Required',
    parameterDescription: 'Description',
    none: 'None',
    additionalPropertiesKey: 'Additional properties',
};

var zh = {
    default: '默认值',
    pattern: '正则匹配',
    example: '示例值',
    enum: '枚举值',
    multipleOf: '倍数',
    characters: '字符',
    required: '必需',
    deprecated: '已废弃',
    readOnly: '只读',
    writeOnly: '只写',
    showAll: '展示全部',
    anyOf: '多选一，只需要符合下列任意一组子节点',
    oneOf: '多选一且必须只能符合下列其中一组子节点（即XOR，异或关系）',
    allOf: '多合一，必须符合下列所有子节点',
    optional: '可选',
    const: '固定值',
    parameterName: '参数名',
    parameterType: '类型',
    parameterRequired: '必需',
    parameterDescription: '说明',
    none: '无',
    additionalPropertiesKey: '额外字段',
};

let g_intl;
const messageMap = {
    'en-US': en,
    'zh-CN': zh,
    'ja-JP': ja,
    'pt-PT': pt,
};
const localeInfo = {
    'en-US': {
        messages: en,
        locale: 'en-US',
    },
    'zh-CN': {
        messages: zh,
        locale: 'zh-CN',
    },
    'ja-JP': {
        messages: ja,
        locale: 'ja-JP',
    },
    'pt-PT': {
        messages: pt,
        locale: 'pt-PT',
    },
};
const getIntl = (locale) => {
    if (g_intl && !locale) {
        return g_intl;
    }
    if (locale && localeInfo[locale]) {
        return reactIntl.createIntl(localeInfo[locale]);
    }
    if (localeInfo['en-US'])
        return reactIntl.createIntl(localeInfo['en-US']);
    return reactIntl.createIntl({
        locale: 'en-US',
        messages: {},
    });
};
const setIntl = (locale) => {
    if (locale) {
        g_intl = getIntl(locale);
    }
};
const formatMessage = (descriptor, values) => {
    const intl = getIntl();
    return intl.formatMessage(descriptor, values);
};
function getLocaleInfo(locale = 'en-US') {
    setIntl(locale);
    return {
        locale: locale,
        messages: messageMap[locale],
    };
}

var styles$1 = {"schema-viewer":"index_schema-viewer__i2ykd"};

const hoveredNodeAtom = jotai.atom(null);
utils.atomFamily((node) => jotai.atom(get => node === get(hoveredNodeAtom)));
utils.atomFamily((parent) => jotai.atom(get => {
    const hoveredNode = get(hoveredNodeAtom);
    if (!hoveredNode || hoveredNode === parent)
        return false;
    return hoveredNode.parent === parent;
}));

const showPathCrumbsAtom = jotai.atom(false);
const pathCrumbsAtom = jotai.atom(get => {
    const node = get(hoveredNodeAtom);
    if (!node)
        return [];
    return propertyPathToObjectPath(node);
});
function propertyPathToObjectPath(node) {
    const objectPath = [];
    let currentNode = node;
    while (currentNode && !jsonSchemaTree.isRootNode(currentNode)) {
        if (jsonSchemaTree.isRegularNode(currentNode)) {
            const pathPart = currentNode.subpath[currentNode.subpath.length - 1];
            if (currentNode.primaryType === 'array') {
                const key = `${pathPart || ''}[]`;
                if (objectPath[objectPath.length - 1]) {
                    objectPath[objectPath.length - 1] = key;
                }
                else {
                    objectPath.push(key);
                }
            }
            else if (pathPart &&
                (currentNode.subpath.length !== 2 || !['allOf', 'oneOf', 'anyOf'].includes(currentNode.subpath[0]))) {
                objectPath.push(currentNode.subpath[currentNode.subpath.length - 1]);
            }
        }
        currentNode = currentNode.parent;
    }
    return objectPath.reverse();
}

const PathCrumbs = ({ parentCrumbs = [] }) => {
    const [showPathCrumbs] = jotai.useAtom(showPathCrumbsAtom);
    const [pathCrumbs] = jotai.useAtom(pathCrumbsAtom);
    const { disableCrumbs } = useJSVOptionsContext();
    if (disableCrumbs) {
        return null;
    }
    const parentCrumbElems = [];
    parentCrumbs.forEach((crumb, i) => {
        parentCrumbElems.push(React__namespace.createElement(mosaic.Box, { key: i }, crumb));
    });
    const pathCrumbElems = [];
    pathCrumbs.forEach((crumb, i) => {
        if (pathCrumbs[i + 1]) {
            pathCrumbElems.push(React__namespace.createElement(mosaic.Box, { key: i }, crumb));
        }
        else {
            pathCrumbElems.push(React__namespace.createElement(mosaic.Box, { key: i, color: "body", fontWeight: "semibold" }, crumb));
        }
    });
    if (!showPathCrumbs || (!parentCrumbElems.length && !pathCrumbElems.length)) {
        return null;
    }
    return (React__namespace.createElement(mosaic.HStack, { spacing: 1, divider: React__namespace.createElement(mosaic.Box, null, "/"), h: "md", mt: -8, borderB: true, pos: "sticky", top: 0, fontFamily: "mono", fontSize: "sm", lineHeight: "none", zIndex: 10, bg: "canvas-pure", px: "px", color: "light", alignItems: "center" },
        parentCrumbElems,
        pathCrumbElems.length && React__namespace.createElement(mosaic.HStack, { divider: React__namespace.createElement(mosaic.Box, { fontWeight: "bold" }, ".") }, pathCrumbElems)));
};

let SKIP_HASHING = false;
const hash = (value, skipHashing = SKIP_HASHING) => {
    return skipHashing ? value : fnv__namespace.fast1a52hex(value);
};
const getNodeId = (node, parentId) => {
    var _a, _b;
    const nodeId = (_b = (_a = node.fragment) === null || _a === void 0 ? void 0 : _a['x-stoplight']) === null || _b === void 0 ? void 0 : _b.id;
    if (nodeId)
        return nodeId;
    const key = node.path[node.path.length - 1];
    return hash(['schema_property', parentId, String(key)].join('-'));
};
const getOriginalNodeId = (node, parentId) => {
    var _a, _b;
    const nodeId = (_b = (_a = node.originalFragment) === null || _a === void 0 ? void 0 : _a['x-stoplight']) === null || _b === void 0 ? void 0 : _b.id;
    if (nodeId)
        return nodeId;
    const key = node.path[node.path.length - 1];
    return hash(['schema_property', parentId, String(key)].join('-'));
};

function isNonNullable(maybeNullable) {
    return maybeNullable !== void 0 && maybeNullable !== null;
}

const isNonEmptyParentNode = (node) => jsonSchemaTree.isRegularNode(node) && !!node.children && node.children.length > 0;
function isFlattenableNode(node) {
    if (!jsonSchemaTree.isRegularNode(node))
        return false;
    if (node.primaryType !== jsonSchemaTree.SchemaNodeKind.Array || !isNonNullable(node.children) || node.children.length === 0) {
        return false;
    }
    return (node.children.length === 1 &&
        (jsonSchemaTree.isRegularNode(node.children[0]) || (jsonSchemaTree.isReferenceNode(node.children[0]) && node.children[0].error !== null)));
}
function isPrimitiveArray(node) {
    return isFlattenableNode(node) && jsonSchemaTree.isRegularNode(node.children[0]) && node.children[0].simple;
}
function isComplexArray(node) {
    return isFlattenableNode(node) && jsonSchemaTree.isRegularNode(node.children[0]) && !node.children[0].simple;
}
function calculateChildrenToShow(node) {
    var _a, _b;
    if (!jsonSchemaTree.isRegularNode(node) || isPrimitiveArray(node)) {
        return [];
    }
    if (isComplexArray(node)) {
        return (_a = node.children[0].children) !== null && _a !== void 0 ? _a : [];
    }
    return (_b = node.children) !== null && _b !== void 0 ? _b : [];
}
function isPropertyRequired(schemaNode) {
    var _a;
    const { parent } = schemaNode;
    if (parent === null || !jsonSchemaTree.isRegularNode(parent) || schemaNode.subpath.length === 0) {
        return false;
    }
    return !!((_a = parent.required) === null || _a === void 0 ? void 0 : _a.includes(schemaNode.subpath[schemaNode.subpath.length - 1]));
}

const Caret = ({ isExpanded }) => (React__namespace.createElement(mosaic.Flex, { pl: 3, w: 8, h: 4, ml: -8, color: "muted", role: "button", "aria-label": "collapse button", justifyContent: "center" },
    React__namespace.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "16", viewBox: "0 0 16 16", fill: "none", style: {
            color: 'var(--ui-text-color-secondary)',
            transform: isExpanded ? 'rotate(0deg)' : 'rotate(270deg)',
        } },
        React__namespace.createElement("path", { d: "M5.37612 7.03978C5.18172 6.70645 5.42212 6.28784 5.80802 6.28784H10.192C10.5779 6.28784 10.8183 6.70645 10.6239 7.03978L8.43191 10.7974C8.23897 11.1282 7.76107 11.1282 7.56813 10.7974L5.37612 7.03978Z", fill: "currentColor" }),
        React__namespace.createElement("path", { d: "M4.06408 6.55979C3.77248 6.0598 4.13308 5.43188 4.71193 5.43188H11.2879C11.8668 5.43188 12.2274 6.0598 11.9357 6.55979L8.64777 12.1963C8.35836 12.6925 7.64151 12.6925 7.3521 12.1963L4.06408 6.55979Z", fill: "currentColor" }))));

function InnerMarkdownViewer({ markdown, style }) {
    return (React__namespace.createElement(mosaic.Box, { className: "sl-markdown-viewer", p: 2 },
        React__namespace.createElement(mosaic.Text, null, markdown)));
}
const Description = ({ value, style, render }) => {
    const [showAll, setShowAll] = React__namespace.useState(false);
    const { displayMode } = useJSVOptionsContext();
    if (typeof value !== 'string' || value.trim().length === 0)
        return null;
    if (render) {
        return (React__namespace.createElement("div", { style: Object.assign(Object.assign({}, style), { marginTop: displayMode === JsonSchemaDisplayMode.classic ? '6px' : undefined }), className: "json-schema-viewer__description" }, render(value)));
    }
    const paragraphs = value.split('\n\n');
    if (paragraphs.length <= 1 || showAll) {
        return (React__namespace.createElement("div", { style: style },
            React__namespace.createElement(mosaic.Box, { as: InnerMarkdownViewer, markdown: value, style: {
                    fontSize: 12,
                } })));
    }
    const firstParagraph = paragraphs[0];
    return (React__namespace.createElement(mosaic.Box, { as: InnerMarkdownViewer, markdown: firstParagraph, parseOptions: {
            components: {
                p: (props) => {
                    return (React__namespace.createElement("div", { style: Object.assign(Object.assign({}, style), { marginTop: displayMode === JsonSchemaDisplayMode.classic ? '4px' : '5px' }) },
                        React__namespace.createElement(mosaic.Box, { as: "p" },
                            React__namespace.createElement(mosaic.Text, { mr: 1 }, props.children),
                            React__namespace.createElement(mosaic.Link, { cursor: "pointer", onClick: () => setShowAll(true) },
                                formatMessage({ id: 'showAll' }),
                                "..."))));
                },
            },
        }, style: {
            fontSize: 12,
        } }));
};

const Format = ({ format }) => {
    return React__namespace.createElement("span", { className: "sl-text-secondary sl-truncate" }, `<${format}>`);
};

function printNameNode(schemaNode, className = 'sl-text-muted-big sl-type', { shouldUseRefNameFallback = false } = {}) {
    if (schemaNode.primaryType !== jsonSchemaTree.SchemaNodeKind.Array ||
        !isNonNullable(schemaNode.children) ||
        schemaNode.children.length === 0) {
        return shouldUseRefNameFallback ? (React__default['default'].createElement("span", { className: className }, getNodeNameFromOriginalRef$3(schemaNode))) : undefined;
    }
    return printArrayName$1(schemaNode, className, { shouldUseRefNameFallback });
}
function printArrayName$1(schemaNode, className, { shouldUseRefNameFallback = false }) {
    var _a, _b, _c, _d;
    if (!isNonNullable(schemaNode.children) || schemaNode.children.length === 0) {
        return (React__default['default'].createElement("span", { className: className }, (_a = schemaNode.title) !== null && _a !== void 0 ? _a : (shouldUseRefNameFallback ? getNodeNameFromOriginalRef$3(schemaNode) : undefined)));
    }
    if (schemaNode.children.length === 1 && jsonSchemaTree.isReferenceNode(schemaNode.children[0])) {
        return React__default['default'].createElement("span", { className: className }, `$ref(${schemaNode.children[0].value})[]`);
    }
    if (isPrimitiveArray(schemaNode)) {
        const val = (_c = (_b = schemaNode.children) === null || _b === void 0 ? void 0 : _b.reduce((mergedTypes, child) => {
            if (mergedTypes === null)
                return null;
            if (!jsonSchemaTree.isRegularNode(child))
                return null;
            if (child.types !== null && child.types.length > 0) {
                const formats = getFormats$1(child);
                for (const type of child.types) {
                    if (mergedTypes.includes(type))
                        continue;
                    mergedTypes.push(`${type}${type in formats ? ` <${formats[type]}>` : ''}`);
                }
            }
            return mergedTypes;
        }, [])) !== null && _c !== void 0 ? _c : null;
        return val !== null && val.length > 0 ? (React__default['default'].createElement("span", { className: className },
            React__default['default'].createElement("span", null, "array"),
            React__default['default'].createElement("span", { className: "sl-text-secondary" }, `[${val.join(' | ')}]`))) : (React__default['default'].createElement("span", { className: className },
            React__default['default'].createElement("span", null, "array")));
    }
    if (isComplexArray(schemaNode)) {
        const firstChild = schemaNode.children[0];
        const childrenNumber = getChildrenNumber$1(firstChild);
        if (firstChild.title) {
            return (React__default['default'].createElement("span", { className: className },
                React__default['default'].createElement("span", null, "array"),
                React__default['default'].createElement("span", { className: "sl-text-secondary" },
                    `[${firstChild.primaryType}`,
                    "\u00A0",
                    `(${firstChild.title})`,
                    `${childrenNumber ? ` {${childrenNumber}}` : ''}]`,
                    "\u00A0")));
        }
        else if (shouldUseRefNameFallback && getNodeNameFromOriginalRef$3(schemaNode)) {
            return (React__default['default'].createElement("span", { className: className },
                React__default['default'].createElement("span", null, "array"),
                React__default['default'].createElement("span", { className: "sl-text-secondary" },
                    `[${getNodeNameFromOriginalRef$3(schemaNode)}]`,
                    "\u00A0")));
        }
        else if (firstChild.primaryType) {
            if (firstChild.primaryType === 'object') {
                return (React__default['default'].createElement("span", { className: className },
                    React__default['default'].createElement("span", null, "array"),
                    React__default['default'].createElement("span", { className: "sl-text-secondary" },
                        "\u00A0",
                        `[${firstChild.primaryType}`,
                        `${childrenNumber ? ` {${childrenNumber}}` : ''}]`,
                        "\u00A0")));
            }
            return (React__default['default'].createElement("span", { className: className },
                React__default['default'].createElement("span", null, "array"),
                React__default['default'].createElement("span", { className: "sl-text-secondary" },
                    "\u00A0",
                    `[${firstChild.primaryType}]`,
                    "\u00A0")));
        }
        else if ((_d = firstChild.combiners) === null || _d === void 0 ? void 0 : _d.length) {
            return (React__default['default'].createElement("span", { className: className },
                React__default['default'].createElement("span", null, "array"),
                React__default['default'].createElement("span", { className: "sl-text-secondary" },
                    "\u00A0",
                    `[${firstChild.combiners.join('/')}]`,
                    "\u00A0")));
        }
        return (React__default['default'].createElement("span", { className: className },
            React__default['default'].createElement("span", null, "array")));
    }
    return undefined;
}
function getNodeNameFromOriginalRef$3(node) {
    if (typeof node.originalFragment.$ref === 'string') {
        return upperFirst__default['default'](json.getLastPathSegment(node.originalFragment.$ref));
    }
    return undefined;
}

var optionalStyles = {"required":"index_required__SSXQb","optional":"index_optional__O33wK","deprecated":"index_deprecated__I1BrF","key":"index_key__iv3g6","value":"index_value__-gcdo","child-stack":"index_child-stack__WPMqo","oneOfContainer":"index_oneOfContainer__gBrRR","xxxOfType":"index_xxxOfType__TtFn-","anyOfTypeTitle":"index_anyOfTypeTitle__6MY8C","anyOfType":"index_anyOfType__1B0NU"};

function shouldRenderName$1(type) {
    return type === jsonSchemaTree.SchemaNodeKind.Array || type === jsonSchemaTree.SchemaNodeKind.Object || type === '$ref';
}
function getTypes$1(schemaNode) {
    var _a;
    if (((_a = schemaNode.fragment) === null || _a === void 0 ? void 0 : _a.type) === 'file') {
        return ['file'];
    }
    return [schemaNode.types, schemaNode.combiners].reduce((values, value) => {
        if (value === null) {
            return values;
        }
        values.push(...value);
        return values;
    }, []);
}
function getFormats$1(schemaNode) {
    const formats = {};
    if (isPrimitiveArray(schemaNode) && schemaNode.children[0].format !== null) {
        formats.array = schemaNode.children[0].format;
    }
    if (schemaNode.format === null) {
        return formats;
    }
    const types = getTypes$1(schemaNode);
    for (const type of types) {
        if (!(type in COMMON_JSON_SCHEMA_AND_OAS_FORMATS))
            continue;
        if (COMMON_JSON_SCHEMA_AND_OAS_FORMATS[type].includes(schemaNode.format)) {
            formats[type] = schemaNode.format;
            return formats;
        }
    }
    formats.string = schemaNode.format;
    return formats;
}
function getChildrenNumber$1(schemaNode) {
    var _a, _b;
    return (_b = (_a = schemaNode.children) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
}
function getNodeNameFromOriginalRef$2(node) {
    if (typeof node.originalFragment.$ref === 'string') {
        return upperFirst__default$1['default'](json.getLastPathSegment(node.originalFragment.$ref));
    }
    return undefined;
}
const Types = ({ schemaNode }) => {
    var _a;
    if (jsonSchemaTree.isReferenceNode(schemaNode)) {
        return (React__namespace.createElement(mosaic.Box, { as: "span", textOverflow: "truncate" }, (_a = schemaNode.value) !== null && _a !== void 0 ? _a : '$ref'));
    }
    if (!jsonSchemaTree.isRegularNode(schemaNode)) {
        return null;
    }
    const types = getTypes$1(schemaNode);
    const formats = getFormats$1(schemaNode);
    const childrenNumber = getChildrenNumber$1(schemaNode);
    if (types.length === 0) {
        return formats.string !== void 0 ? React__namespace.createElement(Format, { format: formats.string }) : null;
    }
    const combinerDescriptionMap = {
        anyOf: formatMessage({ id: 'anyOf' }),
        oneOf: formatMessage({ id: 'oneOf' }),
        allOf: formatMessage({ id: 'allOf' }),
    };
    const rendered = types.map((type, i, { length }) => {
        var _a, _b;
        const isXXXof = type === 'oneOf' || type === 'allOf' || type === 'anyOf';
        const isOneOfOrAnyOf = type === 'oneOf' || type === 'anyOf';
        if (isOneOfOrAnyOf)
            return null;
        const res = (React__namespace.createElement("span", { key: type, className: isXXXof ? optionalStyles.xxxOfType : undefined },
            shouldRenderName$1(type) ? ((_a = printNameNode(schemaNode)) !== null && _a !== void 0 ? _a : (React__namespace.createElement("span", { className: "sl-text-muted-big sl-type" },
                React__namespace.createElement("span", null, type),
                "\u00A0"))) : (React__namespace.createElement("span", { className: "sl-text-muted-big sl-type" },
                ((_b = schemaNode.enum) === null || _b === void 0 ? void 0 : _b.length) ? React__namespace.createElement("span", null,
                    "enum",
                    `<${type}>`) : React__namespace.createElement("span", null, type),
                "\u00A0")),
            type === 'object' &&
                (() => {
                    if (getNodeNameFromOriginalRef$2(schemaNode)) {
                        return React__namespace.createElement("span", { className: "sl-text-secondary sl-truncate" },
                            `(${schemaNode.title})`,
                            "\u00A0");
                    }
                    if (childrenNumber) {
                        React__namespace.createElement("span", { className: "sl-text-secondary sl-truncate" },
                            `{${childrenNumber}}`,
                            "\u00A0");
                    }
                    return null;
                })(),
            isXXXof && childrenNumber ? (React__namespace.createElement("span", { className: "sl-text-secondary sl-truncate" },
                `{${childrenNumber}}`,
                "\u00A0")) : null,
            type in formats && type !== 'array' ? React__namespace.createElement(Format, { format: formats[type] }) : null,
            i < length - 1 && (React__namespace.createElement("span", { key: `${i}-sep`, className: "sl-text-secondary" },
                "\u00A0",
                React__namespace.createElement("span", null, "|"),
                "\u00A0"))));
        if (isXXXof) {
            return React__namespace.createElement(Tooltip__default['default'], { title: combinerDescriptionMap[type] }, res);
        }
        return res;
    });
    return rendered.length > 1 ? (React__namespace.createElement(mosaic.Flex, { alignItems: "center", textOverflow: "truncate", wrap: true }, rendered)) : (React__namespace.createElement(mosaic.Flex, { alignItems: "center", wrap: true }, rendered));
};
Types.displayName = 'JsonSchemaViewer.Types';

const numberValidationNames = [
    'minimum',
    'maximum',
    'minLength',
    'maxLength',
    'minItems',
    'maxItems',
    'exclusiveMinimum',
    'exclusiveMaximum',
];
const exampleValidationNames = ['examples'];
const excludedValidations = ['exclusiveMinimum', 'exclusiveMaximum', 'readOnly', 'writeOnly'];
const numberValidationFormatters = {
    minimum: value => `>= ${value}`,
    exclusiveMinimum: value => `> ${value}`,
    minItems: value => `>= ${value} items`,
    minLength: value => `>= ${value} ${formatMessage({ id: 'characters' })}`,
    maximum: value => `<= ${value}`,
    exclusiveMaximum: value => `< ${value}`,
    maxItems: value => `<= ${value} items`,
    maxLength: value => `<= ${value} ${formatMessage({ id: 'characters' })}`,
};
const createStringFormatter = (nowrap) => (value) => {
    return nowrap && typeof value === 'string' ? value : JSON.stringify(value);
};
const createValidationsFormatter = (name, options) => (value, valueMap) => {
    const values = Array.isArray(value) ? value : [value];
    let result = null;
    if (values.length) {
        result = {
            name: (options === null || options === void 0 ? void 0 : options.exact)
                ? name
                : values.length > 1
                    ? `${formatMessage({ id: name }, { plural: 's' })}`
                    : `${formatMessage({ id: name }, { plural: '' })}`,
            values: values.map(createStringFormatter(options === null || options === void 0 ? void 0 : options.nowrap)),
        };
        if ((options === null || options === void 0 ? void 0 : options.type) === 'enum') {
            result = Object.assign(Object.assign({}, result), { enumDescriptions: valueMap['enumDescriptions'] });
        }
    }
    return result;
};
const validationFormatters = {
    enum: createValidationsFormatter('enum', { nowrap: true, type: 'enum' }),
    examples: createValidationsFormatter('example', { nowrap: true }),
    multipleOf: createValidationsFormatter('multipleOf', {}),
    pattern: createValidationsFormatter('pattern', { nowrap: true }),
    default: createValidationsFormatter('default', { nowrap: true }),
    style: createValidationsFormatter('Style', { exact: true, nowrap: true }),
    enumDescriptions: createValidationsFormatter('enumDescriptions', { nowrap: true }),
    const: createValidationsFormatter('const', { nowrap: true, type: 'const' }),
};
const oasFormats = {
    int32: {
        minimum: 0 - 2 ** 31,
        maximum: 2 ** 31 - 1,
    },
    int64: {
        minimum: 0 - 2 ** 63,
        maximum: 2 ** 63 - 1,
    },
    float: {
        minimum: 0 - 2 ** 128,
        maximum: 2 ** 128 - 1,
    },
    double: {
        minimum: 0 - Number.MAX_VALUE,
        maximum: Number.MAX_VALUE,
    },
    byte: {
        pattern: '^[\\w\\d+\\/=]*$',
    },
};
function filterOutOasFormatValidations(format, values) {
    if (!(format in oasFormats))
        return values;
    const newValues = Object.assign({}, values);
    for (const [key, value] of Object.entries(oasFormats[format])) {
        if (value === newValues[key]) {
            delete newValues[key];
        }
    }
    return newValues;
}
function filterNumberValidations(validations) {
    let result = {};
    forIn__default['default'](validations, (value, key) => {
        if (!((key === 'minimum' && validations['exclusiveMinimum'] === value) ||
            (key === 'maximum' && validations['exclusiveMaximum'] === value))) {
            result[key] = value;
        }
    });
    return result;
}
const Validations = ({ validations, hideExamples, valueRenderMap, displayMode, keyValueRenderMap, }) => {
    const numberValidations = pick__default['default'](validations, numberValidationNames);
    const keyValueValidations = omit__default['default'](validations, [
        ...keys__default['default'](numberValidations),
        ...excludedValidations,
        ...(hideExamples ? exampleValidationNames : []),
    ]);
    if (isEmpty__default['default'](numberValidations) && isEmpty__default['default'](keyValueValidations)) {
        return null;
    }
    return (React__namespace.createElement("div", { style: {
            marginLeft: displayMode === JsonSchemaDisplayMode.classic ? '0px' : '0px',
            gap: '6px',
            display: "flex",
            flexDirection: "column",
            width: "100%"
        } },
        React__namespace.createElement(NumberValidations, { validations: numberValidations }),
        React__namespace.createElement(KeyValueValidations, { validations: keyValueValidations, valueRenderMap: valueRenderMap, keyValueRenderMap: keyValueRenderMap })));
};
const NumberValidations = ({ validations, }) => {
    const entries = Object.entries(filterNumberValidations(validations));
    if (!entries.length) {
        return null;
    }
    return (React__namespace.createElement(mosaic.HStack, { color: "muted", maxW: "full", spacing: 1, style: { gap: 4 } }, entries
        .map(([key, value]) => numberValidationFormatters[key](value))
        .map((value, i) => (React__namespace.createElement(Value, { key: i, name: value })))));
};
const KeyValueValidations = ({ validations, valueRenderMap, keyValueRenderMap, }) => {
    return (React__namespace.createElement(React__namespace.Fragment, null, keys__default['default'](validations)
        .filter(key => Object.keys(validationFormatters).includes(key) &&
        validations[key] !== void 0 &&
        key !== 'enumDescriptions')
        .map(key => {
        const validation = validationFormatters[key](validations[key], validations);
        if (validation) {
            return (React__namespace.createElement(KeyValueValidation, { key: key, name: validation.name, values: validation.values, enumDescriptions: validation.enumDescriptions, type: key, valueRenderMap: valueRenderMap, keyValueRenderMap: keyValueRenderMap }));
        }
        else {
            return null;
        }
    })));
};
const KeyValueValidation = ({ type, name, values, valueRenderMap, enumDescriptions, keyValueRenderMap, }) => {
    const defaultValueNode = (React__namespace.createElement(mosaic.Flex, { flexWrap: true, flex: 1, style: { gap: 6 } }, values.map(value => (React__namespace.createElement(Value, { key: value, name: value, type: type, valueRenderMap: valueRenderMap, enumDescriptions: enumDescriptions })))));
    return (React__namespace.createElement(mosaic.HStack, { color: "muted", spacing: 3, alignItems: "baseline" },
        React__namespace.createElement("span", { className: optionalStyles.key },
            capitalize__default['default'](name),
            ":"),
        React__namespace.createElement("span", null, (keyValueRenderMap === null || keyValueRenderMap === void 0 ? void 0 : keyValueRenderMap[type])
            ? keyValueRenderMap === null || keyValueRenderMap === void 0 ? void 0 : keyValueRenderMap[type](values, defaultValueNode, enumDescriptions)
            : defaultValueNode)));
};
const Value = ({ name, type, valueRenderMap, enumDescriptions, style, }) => {
    if (type && (valueRenderMap === null || valueRenderMap === void 0 ? void 0 : valueRenderMap[type])) {
        return (React__namespace.createElement("span", { className: optionalStyles.value, style: style }, valueRenderMap === null || valueRenderMap === void 0 ? void 0 : valueRenderMap[type](name, enumDescriptions)));
    }
    return (React__namespace.createElement("span", { className: optionalStyles.value, style: style }, name));
};
function getValidationsFromSchema(schemaNode, appNameLower) {
    var _a, _b, _c;
    const result = Object.assign(Object.assign(Object.assign({}, (schemaNode.enum !== null
        ? {
            enum: schemaNode.enum,
            enumDescriptions: (() => {
                var _a, _b, _c;
                const enumList = (_a = schemaNode.fragment) === null || _a === void 0 ? void 0 : _a[`x-${appNameLower}-enum`];
                let deprecatedEnumDescriptionsMap = (_c = (_b = schemaNode.fragment) === null || _b === void 0 ? void 0 : _b[`x-${appNameLower}`]) === null || _c === void 0 ? void 0 : _c.enumDescriptions;
                if (deprecatedEnumDescriptionsMap !== null && typeof deprecatedEnumDescriptionsMap === 'object') ;
                else {
                    deprecatedEnumDescriptionsMap = undefined;
                }
                return Array.isArray(enumList)
                    ? enumList
                    : schemaNode.enum.map(val => {
                        var _a;
                        return {
                            value: val,
                            name: '',
                            description: (_a = deprecatedEnumDescriptionsMap === null || deprecatedEnumDescriptionsMap === void 0 ? void 0 : deprecatedEnumDescriptionsMap[val]) !== null && _a !== void 0 ? _a : '',
                        };
                    });
            })(),
        }
        :
            schemaNode.primaryType === 'array' &&
                ((_a = schemaNode.children) === null || _a === void 0 ? void 0 : _a.length) === 1 &&
                jsonSchemaTree.isRegularNode(schemaNode.children[0]) &&
                schemaNode.children[0].enum !== null
                ? {
                    enum: schemaNode.children[0].enum,
                    enumDescriptions: (() => {
                        var _a, _b, _c;
                        const enumList = (_a = schemaNode.children[0].fragment) === null || _a === void 0 ? void 0 : _a[`x-${appNameLower}-enum`];
                        let deprecatedEnumDescriptionsMap = (_c = (_b = schemaNode.children[0].fragment) === null || _b === void 0 ? void 0 : _b[`x-${appNameLower}`]) === null || _c === void 0 ? void 0 : _c.enumDescriptions;
                        if (deprecatedEnumDescriptionsMap !== null && typeof deprecatedEnumDescriptionsMap === 'object') ;
                        else {
                            deprecatedEnumDescriptionsMap = undefined;
                        }
                        return Array.isArray(enumList)
                            ? enumList
                            : schemaNode.children[0].enum.map(val => {
                                var _a;
                                return {
                                    value: val,
                                    name: '',
                                    description: (_a = deprecatedEnumDescriptionsMap === null || deprecatedEnumDescriptionsMap === void 0 ? void 0 : deprecatedEnumDescriptionsMap[val]) !== null && _a !== void 0 ? _a : '',
                                };
                            });
                    })(),
                }
                : null)), ('annotations' in schemaNode
        ? Object.assign(Object.assign({}, (schemaNode.annotations.default !== void 0 ? { default: schemaNode.annotations.default } : null)), (schemaNode.annotations.examples ? { examples: schemaNode.annotations.examples } : null)) : null)), getFilteredValidations(schemaNode));
    if (typeof ((_b = schemaNode.fragment) === null || _b === void 0 ? void 0 : _b['const']) === 'number') {
        result['const'] = (_c = schemaNode.fragment) === null || _c === void 0 ? void 0 : _c['const'];
        delete result['enum'];
    }
    return result;
}
function getFilteredValidations(schemaNode) {
    if (schemaNode.format !== null) {
        return filterOutOasFormatValidations(schemaNode.format, schemaNode.validations);
    }
    return schemaNode.validations;
}
function getInternalSchemaError(schemaNode, defaultErrorMessage) {
    let errorMessage;
    const fragment = schemaNode.fragment;
    if (typeof fragment === 'object' && fragment !== null) {
        const fragmentErrorMessage = fragment['x-sl-error-message'];
        if (typeof fragmentErrorMessage === 'string') {
            errorMessage = fragmentErrorMessage !== null && fragmentErrorMessage !== void 0 ? fragmentErrorMessage : defaultErrorMessage;
        }
        else {
            const items = fragment['items'];
            if (typeof items === 'object' && items !== null) {
                const itemsErrorMessage = items['x-sl-error-message'];
                if (typeof itemsErrorMessage === 'string') {
                    errorMessage = itemsErrorMessage !== null && itemsErrorMessage !== void 0 ? itemsErrorMessage : defaultErrorMessage;
                }
            }
        }
    }
    return {
        hasError: !!errorMessage,
        error: errorMessage,
    };
}

function printName(schemaNode, { shouldUseRefNameFallback = false } = {}) {
    var _a;
    if (schemaNode.primaryType !== jsonSchemaTree.SchemaNodeKind.Array ||
        !isNonNullable(schemaNode.children) ||
        schemaNode.children.length === 0) {
        return (_a = schemaNode.title) !== null && _a !== void 0 ? _a : (shouldUseRefNameFallback ? getNodeNameFromOriginalRef$1(schemaNode) : undefined);
    }
    return printArrayName(schemaNode, { shouldUseRefNameFallback });
}
function printArrayName(schemaNode, { shouldUseRefNameFallback = false }) {
    var _a, _b, _c, _d;
    if (!isNonNullable(schemaNode.children) || schemaNode.children.length === 0) {
        return (_a = schemaNode.title) !== null && _a !== void 0 ? _a : (shouldUseRefNameFallback ? getNodeNameFromOriginalRef$1(schemaNode) : undefined);
    }
    if (schemaNode.children.length === 1 && jsonSchemaTree.isReferenceNode(schemaNode.children[0])) {
        return `$ref(${schemaNode.children[0].value})[]`;
    }
    if (isPrimitiveArray(schemaNode)) {
        const val = (_c = (_b = schemaNode.children) === null || _b === void 0 ? void 0 : _b.reduce((mergedTypes, child) => {
            if (mergedTypes === null)
                return null;
            if (!jsonSchemaTree.isRegularNode(child))
                return null;
            if (child.types !== null && child.types.length > 0) {
                const formats = getFormats$1(child);
                for (const type of child.types) {
                    if (mergedTypes.includes(type))
                        continue;
                    mergedTypes.push(`${type}${type in formats ? `<${formats[type]}>` : ''}`);
                }
            }
            return mergedTypes;
        }, [])) !== null && _c !== void 0 ? _c : null;
        return val !== null && val.length > 0 ? `array[${val.join(' | ')}]` : 'array';
    }
    if (isComplexArray(schemaNode)) {
        const firstChild = schemaNode.children[0];
        const childrenNumber = getChildrenNumber$1(firstChild);
        if (firstChild.title) {
            return `array[${firstChild.primaryType}(${firstChild.title})${childrenNumber ? `{${childrenNumber}}` : ''}]`;
        }
        else if (shouldUseRefNameFallback && getNodeNameFromOriginalRef$1(schemaNode)) {
            return `array[${getNodeNameFromOriginalRef$1(schemaNode)}]`;
        }
        else if (firstChild.primaryType) {
            if (firstChild.primaryType === 'object') {
                return `array[${firstChild.primaryType}` + (childrenNumber ? `{${childrenNumber}}]` : ']');
            }
            return `array [${firstChild.primaryType}]`;
        }
        else if ((_d = firstChild.combiners) === null || _d === void 0 ? void 0 : _d.length) {
            return `array[${firstChild.combiners.join('/')}]`;
        }
        return 'array';
    }
    return undefined;
}
function getNodeNameFromOriginalRef$1(node) {
    if (typeof node.originalFragment.$ref === 'string') {
        return upperFirst__default['default'](json.getLastPathSegment(node.originalFragment.$ref));
    }
    return undefined;
}

function calculateChoiceTitle(node, isPlural) {
    const primitiveSuffix = isPlural ? 's' : '';
    if (jsonSchemaTree.isRegularNode(node)) {
        const realName = printName(node, { shouldUseRefNameFallback: true });
        if (realName) {
            return realName;
        }
        return node.primaryType !== null ? node.primaryType + primitiveSuffix : 'any';
    }
    if (jsonSchemaTree.isReferenceNode(node)) {
        if (node.value) {
            const value = json.extractPointerFromRef(node.value);
            const lastPiece = !node.error && value ? last__default['default'](json.pointerToPath(value)) : null;
            if (typeof lastPiece === 'string') {
                return lastPiece.split('.')[0];
            }
        }
        return '$ref' + primitiveSuffix;
    }
    return 'any';
}
function makeChoice(node) {
    return {
        type: node,
        title: calculateChoiceTitle(node, false),
    };
}
function makeArrayChoice(node, combiner) {
    const itemTitle = calculateChoiceTitle(node, true);
    const title = itemTitle !== 'any' ? `array ${combiner ? `(${combiner})` : null} [${itemTitle}]` : 'array';
    return {
        type: node,
        title,
    };
}
const getChoicesList = (schemaNode, showSelectorCombiners) => {
    const choices = (() => {
        if (isComplexArray(schemaNode) &&
            isNonEmptyParentNode(schemaNode.children[0]) &&
            shouldShowChildSelector(schemaNode.children[0], showSelectorCombiners)) {
            return schemaNode.children[0].children.map(child => { var _a; return makeArrayChoice(child, (_a = schemaNode.children[0].combiners) === null || _a === void 0 ? void 0 : _a[0]); });
        }
        if (isNonEmptyParentNode(schemaNode) && shouldShowChildSelector(schemaNode, showSelectorCombiners)) {
            return schemaNode.children.map(makeChoice);
        }
        return [makeChoice(schemaNode)];
    })();
    return choices;
};
const useChoices = (schemaNode, showSelectorCombiners) => {
    const choices = React__namespace.useMemo(() => {
        return getChoicesList(schemaNode, showSelectorCombiners);
    }, [schemaNode, showSelectorCombiners]);
    const defaultChoice = choices[0];
    const [selectedChoice, setSelectedChoice] = React__namespace.useState(defaultChoice);
    React__namespace.useEffect(() => {
        setSelectedChoice(defaultChoice);
    }, [defaultChoice]);
    const actualSelectedChoice = selectedChoice && choices.includes(selectedChoice) ? selectedChoice : defaultChoice;
    return { selectedChoice: actualSelectedChoice, setSelectedChoice, choices };
};
const shouldShowChildSelector = (schemaNode, showSelectorCombiners) => {
    var _a, _b;
    if (!showSelectorCombiners) {
        return false;
    }
    const combiners = (Array.isArray(showSelectorCombiners) && showSelectorCombiners.filter(res => res === 'anyOf' || res === 'oneOf')) ||
        [];
    return isNonEmptyParentNode(schemaNode) && combiners.includes((_b = (_a = schemaNode.combiners) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : '');
};

const ChildStack = React__namespace.memo(({ childNodes, currentNestingLevel, className, parentNodeId, parentChangeType, isShowRootLine, isCombinerChild, isParentDeprecated, isOneOfOrAnyOfAndModernDisplay, mb, mt, pb, pt, parentDiscriminatorConfig, skipCollapsibleCheck, }) => {
    const { renderRootTreeLines, displayMode } = useJSVOptionsContext();
    const rootLevel = renderRootTreeLines ? 0 : 1;
    const isRootLevel = currentNestingLevel < rootLevel;
    let ml;
    if (!isRootLevel) {
        ml = currentNestingLevel === rootLevel ? 'px' : 7;
    }
    if (displayMode === JsonSchemaDisplayMode.classic && !isRootLevel) {
        return null;
    }
    const isShowLine = !isOneOfOrAnyOfAndModernDisplay;
    if (displayMode === JsonSchemaDisplayMode.modern && isRootLevel && !skipCollapsibleCheck) {
        if (childNodes.some(childNode => {
            const choices = getChoicesList(childNode);
            const isCollapsible = choices.some(choice => {
                const subChildNodes = calculateChildrenToShow(choice.type);
                const isCollapsible = subChildNodes.length > 0;
                return isCollapsible;
            });
            return isCollapsible;
        })) {
            ml = 2;
        }
    }
    return (React__namespace.createElement(mosaic.Box, { className: className, ml: ml, "data-level": currentNestingLevel, mb: mb, mt: mt, pb: pb, pt: pt },
        displayMode === JsonSchemaDisplayMode.classic && (React__namespace.createElement("div", { className: "sl-flex sl-px-3 sl-text-lg sl-py-1", style: {
                color: 'var(--ui-table-header-color)',
                borderBottom: 'var(--ui-border-width-base) var(--ui-border-style-base) var(--ui-table-border-color)',
            } },
            React__namespace.createElement("div", { style: {
                    width: 200,
                } }, formatMessage({ id: 'parameterName' })),
            React__namespace.createElement("div", { style: {
                    width: 200,
                } }, formatMessage({ id: 'parameterType' })),
            React__namespace.createElement("div", { className: "sl-pl-3", style: {
                    width: 88,
                } }, formatMessage({ id: 'parameterRequired' })),
            React__namespace.createElement("div", { className: "sl-flex-1" }, formatMessage({ id: 'parameterDescription' })))),
        childNodes.map((childNode, index) => (React__namespace.createElement("div", { key: childNode.id, style: { marginLeft: !isRootLevel ? (isShowRootLine ? '30px' : '5px') : '0' }, className: classNames__default['default']((!isRootLevel && isShowLine) || (isRootLevel && isShowRootLine) ? optionalStyles['child-stack'] : '', isCombinerChild ? optionalStyles['combiner-child-stack'] : '') },
            React__namespace.createElement(SchemaRow, { key: childNode.id, schemaNode: childNode, nestingLevel: currentNestingLevel + 1, pl: isRootLevel ? (isShowRootLine ? NESTING_OFFSET : undefined) : NESTING_OFFSET, parentNodeId: parentNodeId, parentChangeType: parentChangeType, isShowRootLine: isShowRootLine, isParentDeprecated: isParentDeprecated, isFirst: index === 0, isLast: index === childNodes.length - 1, isShowLine: isShowLine, parentDiscriminatorConfig: childNode.subpath[childNode.subpath.length] === (parentDiscriminatorConfig === null || parentDiscriminatorConfig === void 0 ? void 0 : parentDiscriminatorConfig.propertyName)
                    ? parentDiscriminatorConfig
                    : undefined }))))));
});
if (process.env.NODE_ENV === 'development') {
    ChildStack.displayName = 'ChildStack';
}

var styles = {"field-name":"index_field-name__eXuGF","additionalInformation":"index_additionalInformation__Krnfu","additionalInformation__title":"index_additionalInformation__title__cjvSn","additionalInformation__combiners-description":"index_additionalInformation__combiners-description__otLMT","node":"index_node__G6-Qx","divider":"index_divider__mzK7A","node__classic":"index_node__classic__TXhTT","array-of":"index_array-of__ck41j","sub-border":"index_sub-border__psSfa","root-border":"index_root-border__ceVNe"};

const parentIsOneOfOrAnyOfAndModernDisplay = true;
const SchemaOneOfRow = React__namespace.memo(({ schemaNode, nestingLevel, pl, parentNodeId, parentChangeType, isDefaultExpanded = false, isShowRootLine, isParentDeprecated, isLast, parentDiscriminatorConfig, }) => {
    var _a, _b, _c, _d, _e, _f;
    const { displayMode, defaultExpandedDepth, renderRowAddon, hideExamples, nodeHasChanged, viewMode, disableTypes, valueRenderMap, keyValueRenderMap, propertyNameRender, descriptionRender, showSelectorCombiners, appNameLower, expandedInfos = {}, } = useJSVOptionsContext();
    const nodeId = getNodeId(schemaNode, parentNodeId);
    const originalNodeId = ((_a = schemaNode.originalFragment) === null || _a === void 0 ? void 0 : _a.$ref) ? getOriginalNodeId(schemaNode, parentNodeId) : nodeId;
    const mode = viewMode === 'standalone' ? undefined : viewMode;
    const hasChanged = nodeHasChanged === null || nodeHasChanged === void 0 ? void 0 : nodeHasChanged({ nodeId: originalNodeId, mode });
    const [isExpanded] = React__namespace.useState(isDefaultExpanded ? true : !jsonSchemaTree.isMirroredNode(schemaNode) && nestingLevel <= defaultExpandedDepth);
    const { selectedChoice, choices } = useChoices(schemaNode, showSelectorCombiners);
    const typeToShow = selectedChoice.type;
    const description = (() => {
        if ('originalFragment' in schemaNode) {
            return schemaNode.originalFragment.description || schemaNode.fragment.description;
        }
        return schemaNode.fragment.description;
    })();
    const refNode = React__namespace.useMemo(() => {
        var _a, _b, _c;
        if (jsonSchemaTree.isReferenceNode(schemaNode)) {
            return schemaNode;
        }
        if (jsonSchemaTree.isRegularNode(schemaNode) &&
            (isFlattenableNode(schemaNode) ||
                (schemaNode.primaryType === jsonSchemaTree.SchemaNodeKind.Array && ((_a = schemaNode.children) === null || _a === void 0 ? void 0 : _a.length) === 1))) {
            return (_c = (_b = schemaNode.children) === null || _b === void 0 ? void 0 : _b.find(jsonSchemaTree.isReferenceNode)) !== null && _c !== void 0 ? _c : null;
        }
        return null;
    }, [schemaNode]);
    const isBrokenRef = typeof (refNode === null || refNode === void 0 ? void 0 : refNode.error) === 'string';
    const childNodes = React__namespace.useMemo(() => calculateChildrenToShow(typeToShow), [typeToShow]);
    const combiner = jsonSchemaTree.isRegularNode(schemaNode) && ((_b = schemaNode.combiners) === null || _b === void 0 ? void 0 : _b.length) ? schemaNode.combiners[0] : null;
    const isCollapsible = displayMode === JsonSchemaDisplayMode.modern && childNodes.length > 0;
    const isOneOfOrAnyOfAndModernDisplay = (combiner === jsonSchemaTree.SchemaCombinerName.AnyOf ||
        combiner === jsonSchemaTree.SchemaCombinerName.OneOf ||
        combiner === jsonSchemaTree.SchemaCombinerName.AllOf) &&
        displayMode === JsonSchemaDisplayMode.modern;
    const required = isPropertyRequired(schemaNode);
    const deprecated = isParentDeprecated ||
        (jsonSchemaTree.isRegularNode(schemaNode) && (schemaNode.deprecated || ((_c = schemaNode.originalFragment) === null || _c === void 0 ? void 0 : _c.deprecated)));
    const validations = jsonSchemaTree.isRegularNode(schemaNode) ? schemaNode.validations : {};
    const isDisabled = (deprecated && (disableTypes === null || disableTypes === void 0 ? void 0 : disableTypes.includes('deprecated'))) ||
        (validations['writeOnly'] && (disableTypes === null || disableTypes === void 0 ? void 0 : disableTypes.includes('writeOnly'))) ||
        (validations['readOnly'] && (disableTypes === null || disableTypes === void 0 ? void 0 : disableTypes.includes('readOnly')));
    const internalSchemaError = getInternalSchemaError(schemaNode);
    const isShowDescriptionInTitle = false;
    if (isDisabled) {
        return null;
    }
    if (parentChangeType === 'added' && hasChanged && hasChanged.type === 'removed') {
        return null;
    }
    if (parentChangeType === 'removed' && hasChanged && hasChanged.type === 'added') {
        return null;
    }
    const propertyNameNode = (React__namespace.createElement(React__namespace.Fragment, null, schemaNode.subpath.length > 0 && shouldShowPropertyName$1(schemaNode) && (React__namespace.createElement(React__namespace.Fragment, null, last__default['default'](schemaNode.subpath) === ADDITIONAL_PROPERTIES_KEY ? (React__namespace.createElement("span", { className: classNames__default['default'](optionalStyles['optional'], 'sl-mr-2 font-semibold'), style: {
            border: 'none',
        } }, formatMessage({ id: 'additionalPropertiesKey' }))) : (React__namespace.createElement("span", { className: deprecated ? 'text-decoration' : '' }, (_e = propertyNameRender === null || propertyNameRender === void 0 ? void 0 : propertyNameRender((_d = last__default['default'](schemaNode.subpath)) !== null && _d !== void 0 ? _d : '')) !== null && _e !== void 0 ? _e : (React__namespace.createElement("div", { className: classNames__default['default'](styles['field-name']) }, last__default['default'](schemaNode.subpath)))))))));
    const propertyTypeNode = (React__namespace.createElement(React__namespace.Fragment, null, choices.length === 1 && (React__namespace.createElement("span", { className: deprecated ? 'text-decoration' : '' },
        React__namespace.createElement(Types, { schemaNode: typeToShow })))));
    const propertyGlobalNode = React__namespace.createElement(React__namespace.Fragment, null, (_f = expandedInfos === null || expandedInfos === void 0 ? void 0 : expandedInfos.typesRightRender) === null || _f === void 0 ? void 0 : _f.call(expandedInfos, schemaNode));
    const descriptionNode = (React__namespace.createElement(React__namespace.Fragment, null,
        typeof description === 'string' &&
            description.length > 0 &&
            (!isShowDescriptionInTitle ) && (React__namespace.createElement("span", { className: classNames__default['default'](deprecated ? 'text-decoration' : '', 'break-all') },
            React__namespace.createElement(Description, { value: description, style: { marginLeft: displayMode === JsonSchemaDisplayMode.classic ? '0px' : '0px' }, render: descriptionRender }))),
        React__namespace.createElement(Validations, { validations: jsonSchemaTree.isRegularNode(schemaNode) ? getValidationsFromSchema(schemaNode, appNameLower) : {}, hideExamples: hideExamples, valueRenderMap: valueRenderMap, keyValueRenderMap: keyValueRenderMap, displayMode: displayMode })));
    const errorIconNode = (isBrokenRef || internalSchemaError.hasError) && (React__namespace.createElement(mosaic.Icon, { title: (refNode === null || refNode === void 0 ? void 0 : refNode.error) || internalSchemaError.error, color: "danger", icon: ['fas', 'exclamation-triangle'], size: "sm" }));
    return (React__namespace.createElement("div", null,
        React__namespace.createElement(mosaic.Flex, { maxW: "full", pl: displayMode === JsonSchemaDisplayMode.classic ? 3 : pl, pr: displayMode === JsonSchemaDisplayMode.classic ? 3 : undefined, mt: displayMode === JsonSchemaDisplayMode.classic ? undefined : 2, mb: (() => {
                if (displayMode === JsonSchemaDisplayMode.classic)
                    return undefined;
                if (isCollapsible && isExpanded)
                    return 0;
                return isLast ? 4 : 0;
            })(), "data-id": originalNodeId, pos: "relative", onMouseEnter: (e) => {
                e.stopPropagation();
            }, className: classNames__default['default'](styles.node, {
                [styles.node__classic]: displayMode === JsonSchemaDisplayMode.classic,
            }), style: {
                borderBottom: displayMode === JsonSchemaDisplayMode.classic && !isLast
                    ? 'var(--ui-border-width-base) var(--ui-border-style-base) var(--ui-table-border-color)'
                    : undefined,
                paddingTop: displayMode === JsonSchemaDisplayMode.classic ? '5px' : undefined,
                paddingBottom: displayMode === JsonSchemaDisplayMode.classic ? '5px' : undefined,
            } },
            displayMode === JsonSchemaDisplayMode.modern && (errorIconNode || descriptionNode) && (React__namespace.createElement(mosaic.VStack, { spacing: 1, maxW: "full", flex: 1, style: { gap: '4px' } },
                React__namespace.createElement(React__namespace.Fragment, null,
                    descriptionNode,
                    errorIconNode))),
            displayMode === JsonSchemaDisplayMode.classic && (React__namespace.createElement(mosaic.VStack, { spacing: 1, maxW: "full", flex: 1, style: { gap: '4px' } },
                React__namespace.createElement("div", { className: "sl-flex" },
                    React__namespace.createElement("div", { className: "sl-flex sl-items-start", style: {
                            width: '200px',
                        } },
                        React__namespace.createElement("div", { style: {
                                wordBreak: 'break-word',
                            } },
                            React__namespace.createElement("div", { className: "sl-flex" }, propertyNameNode)),
                        React__namespace.createElement("div", null, propertyGlobalNode)),
                    React__namespace.createElement("div", { style: {
                            width: '200px',
                        } },
                        React__namespace.createElement("div", { style: {
                                wordBreak: 'break-word',
                            } }, propertyTypeNode)),
                    React__namespace.createElement("div", { className: "sl-flex sl-pl-3", style: {
                            width: '88px',
                            paddingTop: '5px',
                        } },
                        required && React__namespace.createElement(mosaic.Icon, { color: "var(--ui-success-color)", icon: ['fas', 'check'] }),
                        !required && (React__namespace.createElement("svg", { className: "icon", style: {
                                width: '1em',
                                height: '1em',
                                verticalAlign: 'middle',
                                fill: 'var(--ui-disabled-color)',
                                overflow: 'hidden',
                            }, viewBox: "0 0 1024 1024", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "p-id": "25888" },
                            React__namespace.createElement("path", { d: "M153.3515736 153.3515736a62.84360061 62.84360061 0 0 1 88.86085107 0L512 423.13914893l269.78757533-269.78757533a62.84360061 62.84360061 0 1 1 88.86085107 88.86085107L600.86085107 512l269.78757533 269.78757533a62.84360061 62.84360061 0 0 1-88.86085107 88.86085107L512 600.86085107l-269.78757533 269.78757533a62.84360061 62.84360061 0 0 1-88.86085107-88.86085107L423.13914893 512 153.3515736 242.21242467a62.84360061 62.84360061 0 0 1 0-88.86085107z", "p-id": "25889" })))),
                    React__namespace.createElement("div", { className: "sl-flex-1" },
                        React__namespace.createElement("div", { style: {
                                marginTop: -4,
                            } }, descriptionNode))))),
            renderRowAddon ? React__namespace.createElement(mosaic.Box, null, renderRowAddon({ schemaNode, nestingLevel })) : null),
        isCollapsible && isExpanded ? (React__namespace.createElement(React__namespace.Fragment, null, !isOneOfOrAnyOfAndModernDisplay ? (React__namespace.createElement(ChildStack, { schemaNode: schemaNode, childNodes: childNodes, currentNestingLevel: nestingLevel, parentNodeId: nodeId, isShowRootLine: false, parentChangeType: parentChangeType ? parentChangeType : hasChanged ? hasChanged === null || hasChanged === void 0 ? void 0 : hasChanged.type : undefined, isCombinerChild: Boolean(combiner), isParentDeprecated: deprecated, isOneOfOrAnyOfAndModernDisplay: parentIsOneOfOrAnyOfAndModernDisplay, mt: 0, mb: !isLast ? 2 : 0, parentDiscriminatorConfig: parentDiscriminatorConfig })) : (React__namespace.createElement(AnyOfOrOneOfChildStack, { schemaNode: schemaNode, childNodes: childNodes, currentNestingLevel: nestingLevel, parentNodeId: nodeId, isShowRootLine: isShowRootLine && nestingLevel === 1, parentChangeType: parentChangeType ? parentChangeType : hasChanged ? hasChanged === null || hasChanged === void 0 ? void 0 : hasChanged.type : undefined, isCombinerChild: Boolean(combiner), isParentDeprecated: deprecated, mt: 2, mb: !isLast ? 2 : 0, type: combiner === jsonSchemaTree.SchemaCombinerName.AnyOf ? 'anyOf' : 'oneOf' })))) : null));
});
if (process.env.NODE_ENV === 'development') {
    SchemaOneOfRow.displayName = 'SchemaOneOfRow';
}
function shouldShowPropertyName$1(schemaNode) {
    return (schemaNode.subpath.length === 2 &&
        (schemaNode.subpath[0] === 'properties' || schemaNode.subpath[0] === 'patternProperties'));
}

function shouldRenderName(type) {
    return type === jsonSchemaTree.SchemaNodeKind.Array || type === jsonSchemaTree.SchemaNodeKind.Object || type === '$ref';
}
function getTypes(schemaNode) {
    var _a;
    if (((_a = schemaNode.fragment) === null || _a === void 0 ? void 0 : _a.type) === 'file') {
        return ['file'];
    }
    return [schemaNode.types, schemaNode.combiners].reduce((values, value) => {
        if (value === null) {
            return values;
        }
        values.push(...value);
        return values;
    }, []);
}
function getFormats(schemaNode) {
    const formats = {};
    if (isPrimitiveArray(schemaNode) && schemaNode.children[0].format !== null) {
        formats.array = schemaNode.children[0].format;
    }
    if (schemaNode.format === null) {
        return formats;
    }
    const types = getTypes(schemaNode);
    for (const type of types) {
        if (!(type in COMMON_JSON_SCHEMA_AND_OAS_FORMATS))
            continue;
        if (COMMON_JSON_SCHEMA_AND_OAS_FORMATS[type].includes(schemaNode.format)) {
            formats[type] = schemaNode.format;
            return formats;
        }
    }
    formats.string = schemaNode.format;
    return formats;
}
function getChildrenNumber(schemaNode) {
    var _a, _b;
    return (_b = (_a = schemaNode.children) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
}
function getNodeNameFromOriginalRef(node) {
    if (typeof node.originalFragment.$ref === 'string') {
        return upperFirst__default$1['default'](json.getLastPathSegment(node.originalFragment.$ref));
    }
    return undefined;
}
const AnyOfTypes = ({ schemaNode, active, spanRef }) => {
    var _a;
    if (jsonSchemaTree.isReferenceNode(schemaNode)) {
        return (React__namespace.createElement(mosaic.Box, { as: "span", textOverflow: "truncate" }, (_a = schemaNode.value) !== null && _a !== void 0 ? _a : '$ref'));
    }
    if (!jsonSchemaTree.isRegularNode(schemaNode)) {
        return null;
    }
    const types = getTypes(schemaNode);
    const formats = getFormats(schemaNode);
    const childrenNumber = getChildrenNumber(schemaNode);
    if (types.length === 0) {
        return formats.string !== void 0 ? React__namespace.createElement(Format, { format: formats.string }) : null;
    }
    const rendered = types.map((type, i, { length }) => {
        var _a, _b, _c;
        const sourceTitle = isString__default['default'](schemaNode.title) && schemaNode.title ? schemaNode.title : undefined;
        const originTitle = isString__default['default']((_a = schemaNode.originalFragment) === null || _a === void 0 ? void 0 : _a.title) && ((_b = schemaNode.originalFragment) === null || _b === void 0 ? void 0 : _b.title)
            ? (_c = schemaNode.originalFragment) === null || _c === void 0 ? void 0 : _c.title
            : undefined;
        const schemaTitle = sourceTitle || originTitle;
        const typeName = (className = 'sl-oneOf-type sl-type') => {
            var _a;
            return shouldRenderName(type) ? ((_a = printNameNode(schemaNode, className)) !== null && _a !== void 0 ? _a : (React__namespace.createElement("span", { className: className },
                React__namespace.createElement("span", null, type)))) : (React__namespace.createElement("span", { className: className },
                React__namespace.createElement("span", null, type)));
        };
        if (schemaTitle) {
            return (React__namespace.createElement(React__namespace.Fragment, { key: type },
                React__namespace.createElement("span", { className: 'sl-oneOf-type sl-type' },
                    React__namespace.createElement("span", null, schemaTitle)),
                active && spanRef
                    ? ReactDOM__default['default'].createPortal(React__namespace.createElement("span", { className: optionalStyles.anyOfType },
                        typeName('sl-text-secondary sl-truncate'),
                        ' ',
                        type === 'object' && !getNodeNameFromOriginalRef(schemaNode) && childrenNumber ? (React__namespace.createElement("span", { className: "sl-text-secondary sl-truncate" },
                            `{${childrenNumber}}`,
                            "\u00A0")) : null,
                        (type === 'oneOf' || type === 'allOf' || type === 'anyOf') && childrenNumber ? (React__namespace.createElement("span", { className: "sl-text-secondary sl-truncate" },
                            `{${childrenNumber}}`,
                            "\u00A0")) : null,
                        type in formats && type !== 'array' ? React__namespace.createElement(Format, { format: formats[type] }) : null), spanRef)
                    : null,
                i < length - 1 && (React__namespace.createElement("span", { key: `${i}-sep`, className: "sl-text-secondary" },
                    "\u00A0",
                    React__namespace.createElement("span", null, "|"),
                    "\u00A0"))));
        }
        return (React__namespace.createElement(React__namespace.Fragment, { key: type },
            typeName(),
            type === 'object' &&
                (() => {
                    if (getNodeNameFromOriginalRef(schemaNode)) {
                        return React__namespace.createElement("span", { className: "sl-text-secondary sl-truncate" },
                            ` (${schemaNode.title})`,
                            "\u00A0");
                    }
                    if (childrenNumber) {
                        React__namespace.createElement("span", { className: "sl-text-secondary sl-truncate" },
                            ` {${childrenNumber}}`,
                            "\u00A0");
                    }
                    return null;
                })(),
            (type === 'oneOf' || type === 'allOf' || type === 'anyOf') && childrenNumber ? (React__namespace.createElement("span", { className: "sl-text-secondary sl-truncate" },
                ` {${childrenNumber}}`,
                "\u00A0")) : null,
            type in formats && type !== 'array' ? React__namespace.createElement(Format, { format: formats[type] }) : null,
            i < length - 1 && (React__namespace.createElement("span", { key: `${i}-sep`, className: "sl-text-secondary" },
                "\u00A0",
                React__namespace.createElement("span", null, "|"),
                "\u00A0"))));
    });
    return rendered.length > 1 ? (React__namespace.createElement(mosaic.Flex, { alignItems: "center", textOverflow: "truncate", wrap: true }, rendered)) : (React__namespace.createElement(mosaic.Flex, { alignItems: "center", wrap: true }, rendered));
};
AnyOfTypes.displayName = 'JsonSchemaViewer.AnyOfTypes';

function isObject(value) {
    return typeof value === 'object' && value !== null;
}
const AnyOfOrOneOfChildStack = React__namespace.memo(({ schemaNode, childNodes, currentNestingLevel, className, parentNodeId, parentChangeType, isCombinerChild, isParentDeprecated, isShowRootLine, mb, mt, pb, pt, type, }) => {
    var _a, _b, _c;
    const [value, setValue] = React.useState(0);
    const isDiscriminator = jsonSchemaTree.isRegularNode(schemaNode) &&
        isObject((_a = schemaNode === null || schemaNode === void 0 ? void 0 : schemaNode.fragment) === null || _a === void 0 ? void 0 : _a.discriminator) &&
        isObject((_c = (_b = schemaNode === null || schemaNode === void 0 ? void 0 : schemaNode.originalFragment) === null || _b === void 0 ? void 0 : _b.discriminator) === null || _c === void 0 ? void 0 : _c.mapping);
    const discriminatorConfig = isDiscriminator
        ? (() => {
            var _a, _b, _c;
            let discriminatorOptions = childNodes.map(childNode => childNode.fragment.title);
            if (typeof ((_a = schemaNode.originalFragment.discriminator) === null || _a === void 0 ? void 0 : _a.mapping) === 'object' && ((_b = schemaNode.combiners) === null || _b === void 0 ? void 0 : _b[0])) {
                const combiner = schemaNode.combiners[0];
                const mappingEntity = Object.entries((_c = schemaNode.originalFragment.discriminator) === null || _c === void 0 ? void 0 : _c.mapping);
                if (schemaNode.originalFragment[combiner])
                    discriminatorOptions = schemaNode.originalFragment[combiner].map((childNode, index) => {
                        var _a, _b;
                        const ref = childNode.$ref;
                        const res = (_b = (_a = mappingEntity.find(value => value[1] === ref)) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : discriminatorOptions[index];
                        return res;
                    });
            }
            return {
                options: discriminatorOptions,
                propertyName: schemaNode.fragment.discriminator.propertyName,
                activeKey: value,
                setActiveKey: setValue,
            };
        })()
        : undefined;
    const { renderRootTreeLines, displayMode } = useJSVOptionsContext();
    const rootLevel = renderRootTreeLines ? 0 : 1;
    const isRootLevel = currentNestingLevel < rootLevel;
    const [spanRef, setSpanRef] = React.useState(null);
    let ml;
    if (!isRootLevel) {
        ml = currentNestingLevel === rootLevel ? 'px' : 7;
    }
    if (displayMode === JsonSchemaDisplayMode.classic && !isRootLevel) {
        return null;
    }
    const combinerDescriptionMap = {
        anyOf: formatMessage({ id: 'anyOf' }),
        oneOf: formatMessage({ id: 'oneOf' }),
    };
    return (React__namespace.createElement(mosaic.Box, { className: classNames__default['default'](className, optionalStyles.oneOfContainer), ml: ml, "data-level": currentNestingLevel, mb: mb, mt: mt, pb: pb, pt: pt },
        !isDiscriminator && (React__namespace.createElement(mosaic.Flex, { mb: 2 },
            React__namespace.createElement(Tooltip__default['default'], { title: combinerDescriptionMap[type] },
                React__namespace.createElement("span", { className: 'sl-mr-3 flex-shrink-0 ' + optionalStyles.anyOfTypeTitle }, type === 'anyOf' ? 'Any of' : 'One of')),
            React__namespace.createElement(Radio__default['default'].Group, { value: value, onChange: e => setValue(e.target.value), buttonStyle: "separated", size: "small", style: { gap: 4, flexWrap: 'wrap' } }, childNodes.map((schemaNode, index) => {
                var _a;
                const deprecated = isParentDeprecated ||
                    (jsonSchemaTree.isRegularNode(schemaNode) &&
                        (schemaNode.deprecated || ((_a = schemaNode.originalFragment) === null || _a === void 0 ? void 0 : _a.deprecated)));
                const active = value === index;
                return (React__namespace.createElement(Radio__default['default'].Button, { value: index, key: schemaNode.id, className: "overflow-hidden" },
                    React__namespace.createElement("span", { className: deprecated ? 'text-decoration inline-flex' : 'inline-flex', key: schemaNode.id },
                        React__namespace.createElement(AnyOfTypes, { schemaNode: schemaNode, active: active, spanRef: spanRef }))));
            })),
            React__namespace.createElement("span", { ref: setSpanRef, className: "mr-3" }))),
        (() => {
            const childNode = childNodes[value];
            return (React__namespace.createElement("div", { key: childNode.id, style: { marginLeft: !isRootLevel ? '5px' : '0' }, className: classNames__default['default'](isCombinerChild ? optionalStyles['combiner-child-stack'] : '') },
                React__namespace.createElement(SchemaOneOfRow, { key: childNode.id, schemaNode: childNode, nestingLevel: 1, pl: isRootLevel ? (isShowRootLine ? NESTING_OFFSET : undefined) : NESTING_OFFSET, parentNodeId: parentNodeId, parentChangeType: parentChangeType, isShowRootLine: isShowRootLine, isParentDeprecated: isParentDeprecated, isLast: true, isDefaultExpanded: true, parentDiscriminatorConfig: discriminatorConfig })));
        })()));
});
if (process.env.NODE_ENV === 'development') {
    AnyOfOrOneOfChildStack.displayName = 'AnyOfOrOneOfChildStack';
}

const Properties = ({ required, deprecated, validations: { readOnly, writeOnly }, }) => {
    const showVisibilityValidations = !!readOnly !== !!writeOnly;
    const visibility = showVisibilityValidations ? (readOnly ? (React__namespace.createElement(mosaic.Box, { as: "span", ml: 2, mr: 2, color: "muted" }, formatMessage({ id: 'readOnly' }))) : (React__namespace.createElement(mosaic.Box, { as: "span", ml: 2, mr: 2, color: "muted" }, formatMessage({ id: 'writeOnly' })))) : null;
    if (deprecated) {
        return React__namespace.createElement("span", { className: optionalStyles['deprecated'] }, formatMessage({ id: 'deprecated' }));
    }
    return (React__namespace.createElement(React__namespace.Fragment, null,
        visibility,
        required ? (React__namespace.createElement("span", { className: optionalStyles['required'] }, formatMessage({ id: 'required' }))) : (React__namespace.createElement("span", { className: optionalStyles['optional'] }, formatMessage({ id: 'optional' })))));
};

const SchemaRow = React__namespace.memo(({ schemaNode, nestingLevel, pl, parentNodeId, parentChangeType, isDefaultExpanded = false, isShowRootLine, isShowLine = true, isParentDeprecated, isFirst, isLast, parentDiscriminatorConfig, }) => {
    var _a, _b, _c, _d, _e, _f;
    const { displayMode, defaultExpandedDepth, renderRowAddon, onGoToRef, hideExamples, renderRootTreeLines, nodeHasChanged, viewMode, disableTypes, valueRenderMap, keyValueRenderMap, propertyNameRender, descriptionRender, showSelectorCombiners, isStateRightAligned = true, enableDescriptionShowInTitle = true, appNameLower, expandedInfos = {}, } = useJSVOptionsContext();
    const nodeId = getNodeId(schemaNode, parentNodeId);
    const originalNodeId = ((_a = schemaNode.originalFragment) === null || _a === void 0 ? void 0 : _a.$ref) ? getOriginalNodeId(schemaNode, parentNodeId) : nodeId;
    const mode = viewMode === 'standalone' ? undefined : viewMode;
    const hasChanged = nodeHasChanged === null || nodeHasChanged === void 0 ? void 0 : nodeHasChanged({ nodeId: originalNodeId, mode });
    const [isExpanded, setExpanded] = React__namespace.useState(isDefaultExpanded ? true : !jsonSchemaTree.isMirroredNode(schemaNode) && nestingLevel <= defaultExpandedDepth);
    const { selectedChoice, setSelectedChoice, choices } = useChoices(schemaNode, showSelectorCombiners);
    const typeToShow = selectedChoice.type;
    const description = (() => {
        if ('originalFragment' in schemaNode) {
            return schemaNode.originalFragment.description || schemaNode.fragment.description;
        }
        return schemaNode.fragment.description;
    })();
    const refNode = React__namespace.useMemo(() => {
        var _a, _b, _c;
        if (jsonSchemaTree.isReferenceNode(schemaNode)) {
            return schemaNode;
        }
        if (jsonSchemaTree.isRegularNode(schemaNode) &&
            (isFlattenableNode(schemaNode) ||
                (schemaNode.primaryType === jsonSchemaTree.SchemaNodeKind.Array && ((_a = schemaNode.children) === null || _a === void 0 ? void 0 : _a.length) === 1))) {
            return (_c = (_b = schemaNode.children) === null || _b === void 0 ? void 0 : _b.find(jsonSchemaTree.isReferenceNode)) !== null && _c !== void 0 ? _c : null;
        }
        return null;
    }, [schemaNode]);
    const isBrokenRef = typeof (refNode === null || refNode === void 0 ? void 0 : refNode.error) === 'string';
    const rootLevel = renderRootTreeLines ? 1 : 2;
    const childNodes = React__namespace.useMemo(() => calculateChildrenToShow(typeToShow), [typeToShow]);
    const combiner = jsonSchemaTree.isRegularNode(schemaNode) && ((_b = schemaNode.combiners) === null || _b === void 0 ? void 0 : _b.length) ? schemaNode.combiners[0] : null;
    const isCollapsible = displayMode === JsonSchemaDisplayMode.modern && childNodes.length > 0;
    const isRootLevel = nestingLevel < rootLevel;
    const isOneOfOrAnyOfAndModernDisplay = (combiner === jsonSchemaTree.SchemaCombinerName.AnyOf || combiner === jsonSchemaTree.SchemaCombinerName.OneOf) &&
        displayMode === JsonSchemaDisplayMode.modern;
    const required = isPropertyRequired(schemaNode);
    const deprecated = isParentDeprecated ||
        (jsonSchemaTree.isRegularNode(schemaNode) && (schemaNode.deprecated || ((_c = schemaNode.originalFragment) === null || _c === void 0 ? void 0 : _c.deprecated)));
    const validations = jsonSchemaTree.isRegularNode(schemaNode) ? schemaNode.validations : {};
    const title = (() => {
        var _a, _b;
        const originalFragmentTitle = mosaic.isString((_a = schemaNode.originalFragment) === null || _a === void 0 ? void 0 : _a.title) && ((_b = schemaNode.originalFragment) === null || _b === void 0 ? void 0 : _b.title)
            ? schemaNode.originalFragment.title
            : undefined;
        const fragmentTitle = mosaic.isString(schemaNode.fragment.title) && schemaNode.fragment.title ? schemaNode.fragment.title : undefined;
        if (isOneOfOrAnyOfAndModernDisplay) {
            return originalFragmentTitle !== null && originalFragmentTitle !== void 0 ? originalFragmentTitle : fragmentTitle;
        }
        return originalFragmentTitle;
    })();
    const isDisabled = (deprecated && (disableTypes === null || disableTypes === void 0 ? void 0 : disableTypes.includes('deprecated'))) ||
        (validations['writeOnly'] && (disableTypes === null || disableTypes === void 0 ? void 0 : disableTypes.includes('writeOnly'))) ||
        (validations['readOnly'] && (disableTypes === null || disableTypes === void 0 ? void 0 : disableTypes.includes('readOnly')));
    const internalSchemaError = getInternalSchemaError(schemaNode);
    const annotationRootOffset = renderRootTreeLines ? 0 : 8;
    let annotationLeftOffset = -20 - annotationRootOffset;
    const hasTitle = title;
    const isShowDescriptionInTitle = enableDescriptionShowInTitle &&
        getIntl().locale === 'zh-CN' &&
        !hasTitle &&
        typeof description === 'string' &&
        description.length > 0 &&
        description.length < 10;
    if (isDisabled) {
        return null;
    }
    if (nestingLevel > 1) {
        annotationLeftOffset =
            -1 * 29 * Math.max(nestingLevel - 1, 1) - Math.min(nestingLevel, 2) * 2 - 16 - annotationRootOffset;
        if (!renderRootTreeLines) {
            annotationLeftOffset += 27;
        }
    }
    if (parentChangeType === 'added' && hasChanged && hasChanged.type === 'removed') {
        return null;
    }
    if (parentChangeType === 'removed' && hasChanged && hasChanged.type === 'added') {
        return null;
    }
    const propertyNameNode = (React__namespace.createElement(React__namespace.Fragment, null, schemaNode.subpath.length > 0 && shouldShowPropertyName(schemaNode) && (React__namespace.createElement(React__namespace.Fragment, null, last__default['default'](schemaNode.subpath) === ADDITIONAL_PROPERTIES_KEY ? (React__namespace.createElement("span", { className: classNames__default['default'](optionalStyles['optional'], 'sl-mr-2 font-semibold'), style: {
            border: 'none',
        } }, formatMessage({ id: 'additionalPropertiesKey' }))) : (React__namespace.createElement("span", { className: deprecated ? 'text-decoration' : '' }, (_e = propertyNameRender === null || propertyNameRender === void 0 ? void 0 : propertyNameRender((_d = last__default['default'](schemaNode.subpath)) !== null && _d !== void 0 ? _d : '')) !== null && _e !== void 0 ? _e : (React__namespace.createElement("div", { className: classNames__default['default'](styles['field-name']) }, last__default['default'](schemaNode.subpath)))))))));
    const propertyTypeNode = (React__namespace.createElement(React__namespace.Fragment, null, choices.length === 1 && (React__namespace.createElement("span", { className: deprecated ? 'text-decoration' : '' },
        React__namespace.createElement(Types, { schemaNode: typeToShow })))));
    const discriminatorSelector = (parentDiscriminatorConfig === null || parentDiscriminatorConfig === void 0 ? void 0 : parentDiscriminatorConfig.options) ? (React__namespace.createElement(Radio__default['default'].Group, { value: parentDiscriminatorConfig.activeKey, onChange: e => parentDiscriminatorConfig.setActiveKey(e.target.value), buttonStyle: "separated", size: "small", style: { gap: 4, flexWrap: 'wrap' } }, parentDiscriminatorConfig.options.map((v, index) => {
        var _a;
        const deprecated = isParentDeprecated ||
            (jsonSchemaTree.isRegularNode(schemaNode) && (schemaNode.deprecated || ((_a = schemaNode.originalFragment) === null || _a === void 0 ? void 0 : _a.deprecated)));
        return (React__namespace.createElement(Radio__default['default'].Button, { value: index, key: schemaNode.id, className: "overflow-hidden" },
            React__namespace.createElement("span", { className: deprecated ? 'text-decoration inline-flex' : 'inline-flex', key: schemaNode.id }, v)));
    }))) : null;
    const propertyGlobalNode = React__namespace.createElement(React__namespace.Fragment, null, (_f = expandedInfos === null || expandedInfos === void 0 ? void 0 : expandedInfos.typesRightRender) === null || _f === void 0 ? void 0 : _f.call(expandedInfos, schemaNode));
    const propertyOtherNode = (React__namespace.createElement(React__namespace.Fragment, null,
        onGoToRef && jsonSchemaTree.isReferenceNode(schemaNode) && schemaNode.external ? (React__namespace.createElement(mosaic.Box, { as: "a", ml: 2, cursor: "pointer", color: "primary-light", onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
                onGoToRef(schemaNode);
            } }, "(go to ref)")) : null,
        schemaNode.subpath.length > 1 && schemaNode.subpath[0] === 'patternProperties' ? (React__namespace.createElement(mosaic.Box, { ml: 2, color: "muted" }, "(pattern property)")) : null,
        choices.length > 1 && (React__namespace.createElement(mosaic.Select, { "aria-label": "Pick a type", size: "sm", triggerTextPrefix: combiner ? `${COMBINER_NAME_MAP[combiner]}: ` : undefined, options: choices.map((choice, index) => ({
                value: String(index),
                label: choice.title,
            })), value: String(choices.indexOf(selectedChoice)), onChange: selectedIndex => setSelectedChoice(choices[selectedIndex]) }))));
    const schemaDiscriminator = discriminatorSelector ? (React__namespace.createElement("div", { style: { marginLeft: displayMode === JsonSchemaDisplayMode.classic ? '0px' : '0px' } },
        React__namespace.createElement("span", { className: "sl-mr-2" }, "Discriminator"),
        discriminatorSelector)) : null;
    const schemaTitleNode = (React__namespace.createElement(mosaic.Flex, { alignItems: "center", maxW: "full", onClick: isCollapsible ? () => setExpanded(!isExpanded) : undefined, cursor: isCollapsible ? 'pointer' : undefined },
        isCollapsible ? React__namespace.createElement(Caret, { isExpanded: isExpanded }) : null,
        React__namespace.createElement(mosaic.Flex, { alignItems: "center", fontSize: "base", textOverflow: "truncate" },
            propertyNameNode,
            propertyTypeNode,
            propertyGlobalNode,
            propertyOtherNode),
        React__namespace.createElement("div", { className: classNames__default['default'](styles.additionalInformation, isStateRightAligned ? '' : 'sl-flex-initial') },
            React__namespace.createElement("div", { className: classNames__default['default']('truncate sl-type', deprecated ? 'text-decoration' : '') },
                title && (React__namespace.createElement("span", { title: title, className: styles.additionalInformation__title }, title)),
                isShowDescriptionInTitle && (React__namespace.createElement("span", { title: description, className: styles.additionalInformation__title }, description))),
            isStateRightAligned && React__namespace.createElement(Divider, null)),
        React__namespace.createElement(Properties, { required: required, deprecated: deprecated, validations: validations })));
    const descriptionNode = (React__namespace.createElement(React__namespace.Fragment, null,
        typeof description === 'string' &&
            description.length > 0 &&
            (!isShowDescriptionInTitle || displayMode === JsonSchemaDisplayMode.classic) && (React__namespace.createElement("span", { className: classNames__default['default'](deprecated ? 'text-decoration' : '', 'break-all') },
            React__namespace.createElement(Description, { value: description, style: { marginLeft: displayMode === JsonSchemaDisplayMode.classic ? '0px' : '0px' }, render: descriptionRender }))),
        React__namespace.createElement(Validations, { validations: jsonSchemaTree.isRegularNode(schemaNode) ? getValidationsFromSchema(schemaNode, appNameLower) : {}, hideExamples: hideExamples, valueRenderMap: valueRenderMap, keyValueRenderMap: keyValueRenderMap, displayMode: displayMode })));
    const errorIconNode = (isBrokenRef || internalSchemaError.hasError) && (React__namespace.createElement(mosaic.Icon, { title: (refNode === null || refNode === void 0 ? void 0 : refNode.error) || internalSchemaError.error, color: "danger", icon: ['fas', 'exclamation-triangle'], size: "sm" }));
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(mosaic.Box, { maxW: "full", mt: displayMode === JsonSchemaDisplayMode.classic ? undefined : (isFirst ? (isRootLevel ? 0 : 4) : 4), mb: (() => {
                if (displayMode === JsonSchemaDisplayMode.classic)
                    return undefined;
                if (isCollapsible && isExpanded)
                    return 0;
                return isLast ? 4 : 0;
            })(), "data-id": originalNodeId, pos: "relative", onMouseEnter: (e) => {
                e.stopPropagation();
            }, className: classNames__default['default'](styles.node, {
                [styles.node__classic]: displayMode === JsonSchemaDisplayMode.classic,
            }), style: {
                borderBottom: displayMode === JsonSchemaDisplayMode.classic && !isLast
                    ? 'var(--ui-border-width-base) var(--ui-border-style-base) var(--ui-table-border-color)'
                    : undefined,
                paddingTop: displayMode === JsonSchemaDisplayMode.classic ? '5px' : undefined,
                paddingBottom: displayMode === JsonSchemaDisplayMode.classic ? '5px' : undefined,
            } },
            React__namespace.createElement(mosaic.Flex, { w: "full", pl: displayMode === JsonSchemaDisplayMode.classic ? 3 : pl, pr: displayMode === JsonSchemaDisplayMode.classic ? 3 : undefined, pos: "relative" },
                ((!isRootLevel && isShowLine) || (isRootLevel && isShowRootLine)) && (React__namespace.createElement("div", { className: classNames__default['default'](styles['sub-border']), style: isFirst
                        ? {
                            marginTop: -8,
                            height: 20,
                        }
                        : undefined })),
                parentChangeType !== 'added' && parentChangeType !== 'removed' ? (React__namespace.createElement(mosaic.NodeAnnotation, { change: hasChanged, style: { left: annotationLeftOffset } })) : null,
                React__namespace.createElement(mosaic.VStack, { spacing: 1, maxW: "full", flex: 1, style: { gap: '6px' } },
                    displayMode === JsonSchemaDisplayMode.modern && (React__namespace.createElement(React__namespace.Fragment, null,
                        schemaTitleNode,
                        descriptionNode,
                        errorIconNode,
                        schemaDiscriminator)),
                    displayMode === JsonSchemaDisplayMode.classic && (React__namespace.createElement(React__namespace.Fragment, null,
                        React__namespace.createElement("div", { className: "sl-flex" },
                            React__namespace.createElement("div", { className: "sl-flex sl-items-start", style: {
                                    width: '200px',
                                } },
                                React__namespace.createElement("div", { style: {
                                        wordBreak: 'break-word',
                                    } },
                                    React__namespace.createElement("div", { className: "sl-flex" }, propertyNameNode)),
                                React__namespace.createElement("div", null, propertyGlobalNode)),
                            React__namespace.createElement("div", { style: {
                                    width: '200px',
                                } },
                                React__namespace.createElement("div", { style: {
                                        wordBreak: 'break-word',
                                    } }, propertyTypeNode)),
                            React__namespace.createElement("div", { className: "sl-flex sl-pl-3", style: {
                                    width: '88px',
                                    paddingTop: '5px',
                                } },
                                required && React__namespace.createElement(mosaic.Icon, { color: "var(--ui-success-color)", icon: ['fas', 'check'] }),
                                !required && (React__namespace.createElement("svg", { className: "icon", style: {
                                        width: '1em',
                                        height: '1em',
                                        verticalAlign: 'middle',
                                        fill: 'var(--ui-disabled-color)',
                                        overflow: 'hidden',
                                    }, viewBox: "0 0 1024 1024", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "p-id": "25888" },
                                    React__namespace.createElement("path", { d: "M153.3515736 153.3515736a62.84360061 62.84360061 0 0 1 88.86085107 0L512 423.13914893l269.78757533-269.78757533a62.84360061 62.84360061 0 1 1 88.86085107 88.86085107L600.86085107 512l269.78757533 269.78757533a62.84360061 62.84360061 0 0 1-88.86085107 88.86085107L512 600.86085107l-269.78757533 269.78757533a62.84360061 62.84360061 0 0 1-88.86085107-88.86085107L423.13914893 512 153.3515736 242.21242467a62.84360061 62.84360061 0 0 1 0-88.86085107z", "p-id": "25889" })))),
                            React__namespace.createElement("div", { className: "sl-flex-1" },
                                React__namespace.createElement("div", { style: {
                                        marginTop: -4,
                                    } }, descriptionNode),
                                schemaDiscriminator))))),
                renderRowAddon ? React__namespace.createElement(mosaic.Box, null, renderRowAddon({ schemaNode, nestingLevel })) : null)),
        isCollapsible && isExpanded ? (React__namespace.createElement(React__namespace.Fragment, null, !isOneOfOrAnyOfAndModernDisplay ? (React__namespace.createElement(ChildStack, { schemaNode: schemaNode, childNodes: childNodes, currentNestingLevel: nestingLevel, parentNodeId: nodeId, isShowRootLine: isShowRootLine && nestingLevel === 1, parentChangeType: parentChangeType ? parentChangeType : hasChanged ? hasChanged === null || hasChanged === void 0 ? void 0 : hasChanged.type : undefined, isCombinerChild: Boolean(combiner), isParentDeprecated: deprecated, mt: 0, mb: !isLast ? 4 : 0 })) : (React__namespace.createElement(AnyOfOrOneOfChildStack, { schemaNode: schemaNode, childNodes: childNodes, currentNestingLevel: nestingLevel, parentNodeId: nodeId, isShowRootLine: isShowRootLine && nestingLevel === 1, parentChangeType: parentChangeType ? parentChangeType : hasChanged ? hasChanged === null || hasChanged === void 0 ? void 0 : hasChanged.type : undefined, isCombinerChild: Boolean(combiner), isParentDeprecated: deprecated, mt: 2, mb: !isLast ? 4 : 0, type: combiner === jsonSchemaTree.SchemaCombinerName.AnyOf ? 'anyOf' : 'oneOf' })))) : null));
});
if (process.env.NODE_ENV === 'development') {
    SchemaRow.displayName = 'SchemaRow';
}
const Divider = () => {
    return React__namespace.createElement("div", { className: classNames__default['default'](styles.divider) });
};
function shouldShowPropertyName(schemaNode) {
    return (schemaNode.subpath.length === 2 &&
        (schemaNode.subpath[0] === 'properties' || schemaNode.subpath[0] === 'patternProperties'));
}

const TopLevelSchemaRow = ({ schemaNode, skipDescription, showSelectorCombiners, }) => {
    var _a, _b, _c;
    const { displayMode } = useJSVOptionsContext();
    const { selectedChoice, setSelectedChoice, choices } = useChoices(schemaNode, showSelectorCombiners);
    const childNodes = React__namespace.useMemo(() => calculateChildrenToShow(selectedChoice.type), [selectedChoice.type]);
    const nestingLevel = 0;
    const nodeId = (_b = (_a = schemaNode.fragment) === null || _a === void 0 ? void 0 : _a['x-stoplight']) === null || _b === void 0 ? void 0 : _b.id;
    const internalSchemaError = getInternalSchemaError(schemaNode);
    const isEmptyObjectNode = schemaNode.primaryType === 'object' && !isNonEmptyParentNode(schemaNode);
    if (isEmptyObjectNode) {
        return (React__namespace.createElement("span", { className: "flex items-center sl-py-2" },
            displayMode === JsonSchemaDisplayMode.modern && (React__namespace.createElement(React__namespace.Fragment, null,
                React__namespace.createElement("span", { className: "sl-text-muted-big" }, "object"),
                "\u00A0",
                React__namespace.createElement("span", { className: "sl-text-secondary" }, '{0}'))),
            displayMode === JsonSchemaDisplayMode.classic && (React__namespace.createElement("span", { className: "sl-pl-3" }, formatMessage({ id: 'none' })))));
    }
    if (jsonSchemaTree.isRegularNode(schemaNode) && isPureObjectNode(schemaNode)) {
        return (React__namespace.createElement(React__namespace.Fragment, null,
            React__namespace.createElement(ScrollCheck, null),
            !skipDescription ? React__namespace.createElement(Description, { value: schemaNode.annotations.description }) : null,
            React__namespace.createElement(ChildStack, { schemaNode: schemaNode, childNodes: childNodes, currentNestingLevel: nestingLevel, parentNodeId: nodeId }),
            internalSchemaError.hasError && (React__namespace.createElement(mosaic.Icon, { title: internalSchemaError.error, color: "danger", icon: ['fas', 'exclamation-triangle'], size: "sm" }))));
    }
    if (jsonSchemaTree.isRegularNode(schemaNode) && choices.length > 1) {
        const combiner = jsonSchemaTree.isRegularNode(schemaNode) && ((_c = schemaNode.combiners) === null || _c === void 0 ? void 0 : _c.length) ? schemaNode.combiners[0] : null;
        return (React__namespace.createElement(React__namespace.Fragment, null,
            React__namespace.createElement(ScrollCheck, null),
            React__namespace.createElement(Description, { value: schemaNode.annotations.description }),
            React__namespace.createElement(mosaic.HStack, { spacing: 3, pb: 4 },
                React__namespace.createElement(mosaic.Menu, { "aria-label": "Pick a type", closeOnPress: true, placement: "bottom left", items: choices.map((choice, index) => ({
                        id: index,
                        title: choice.title,
                        onPress: () => setSelectedChoice(choice),
                    })), renderTrigger: props => (React__namespace.createElement(mosaic.Pressable, Object.assign({}, props),
                        React__namespace.createElement(mosaic.Flex, { fontFamily: "mono", fontWeight: "semibold", cursor: "pointer", fontSize: "base" },
                            selectedChoice.title,
                            React__namespace.createElement(mosaic.Flex, { ml: 1, alignItems: "center" },
                                React__namespace.createElement(mosaic.Icon, { icon: ['fas', 'caret-down'] }))))) }),
                combiner !== null ? (React__namespace.createElement(mosaic.Flex, { alignItems: "center", color: "muted", fontSize: "base" }, `(${COMBINER_NAME_MAP[combiner]})`)) : null),
            childNodes.length > 0 ? (React__namespace.createElement(ChildStack, { schemaNode: schemaNode, childNodes: childNodes, currentNestingLevel: nestingLevel, parentNodeId: nodeId, isCombinerChild: Boolean(combiner) })) : null));
    }
    if (isComplexArray(schemaNode) && isPureObjectNode(schemaNode.children[0])) {
        return (React__namespace.createElement("div", { style: { marginLeft: 16 } },
            React__namespace.createElement(ScrollCheck, null),
            React__namespace.createElement(Description, { value: schemaNode.annotations.description, style: { marginLeft: '-13px' } }),
            React__namespace.createElement("div", { className: styles['array-of'] }, "array of:"),
            childNodes.length > 0 ? (React__namespace.createElement(ChildStack, { schemaNode: schemaNode, childNodes: childNodes, currentNestingLevel: nestingLevel, parentNodeId: nodeId, isShowRootLine: true, skipCollapsibleCheck: true })) : null));
    }
    let ml = 0;
    if (displayMode === JsonSchemaDisplayMode.modern) {
        if (calculateChildrenToShow(schemaNode).some(childNode => {
            const choices = getChoicesList(childNode);
            const isCollapsible = choices.some(choice => {
                const subChildNodes = calculateChildrenToShow(choice.type);
                const isCollapsible = subChildNodes.length > 0;
                return isCollapsible;
            });
            return isCollapsible;
        })) {
            ml = 2;
        }
    }
    return (React__namespace.createElement("div", { style: { marginLeft: ml * 4 } },
        React__namespace.createElement(ScrollCheck, null),
        React__namespace.createElement(SchemaRow, { schemaNode: schemaNode, nestingLevel: nestingLevel })));
};
function ScrollCheck() {
    const elementRef = React__namespace.useRef(null);
    return React__namespace.createElement("div", { ref: elementRef });
}
function isPureObjectNode(schemaNode) {
    var _a;
    return schemaNode.primaryType === 'object' && ((_a = schemaNode.types) === null || _a === void 0 ? void 0 : _a.length) === 1;
}

const JsonSchemaViewerComponent = (_a) => {
    var { displayMode = JsonSchemaDisplayMode.modern, viewMode = 'standalone', defaultExpandedDepth = 1, onGoToRef, renderRowAddon, hideExamples, renderRootTreeLines, disableCrumbs, nodeHasChanged, skipTopLevelDescription, disableTypes, valueRenderMap, keyValueRenderMap, locale, propertyNameRender, descriptionRender, showSelectorCombiners, isMergeAllOf, enableDescriptionShowInTitle, expandedInfos, appNameLower } = _a, rest = __rest(_a, ["displayMode", "viewMode", "defaultExpandedDepth", "onGoToRef", "renderRowAddon", "hideExamples", "renderRootTreeLines", "disableCrumbs", "nodeHasChanged", "skipTopLevelDescription", "disableTypes", "valueRenderMap", "keyValueRenderMap", "locale", "propertyNameRender", "descriptionRender", "showSelectorCombiners", "isMergeAllOf", "enableDescriptionShowInTitle", "expandedInfos", "appNameLower"]);
    const options = React__namespace.useMemo(() => ({
        defaultExpandedDepth,
        viewMode,
        onGoToRef,
        renderRowAddon,
        hideExamples,
        renderRootTreeLines,
        disableCrumbs,
        nodeHasChanged,
        disableTypes,
        valueRenderMap,
        keyValueRenderMap,
        locale,
        propertyNameRender,
        descriptionRender,
        showSelectorCombiners,
        isMergeAllOf,
        isStateRightAligned: true,
        enableDescriptionShowInTitle,
        expandedInfos,
        displayMode,
        appNameLower,
    }), [
        defaultExpandedDepth,
        viewMode,
        onGoToRef,
        renderRowAddon,
        hideExamples,
        renderRootTreeLines,
        disableCrumbs,
        nodeHasChanged,
        disableTypes,
        valueRenderMap,
        keyValueRenderMap,
        locale,
        propertyNameRender,
        descriptionRender,
        showSelectorCombiners,
        isMergeAllOf,
        enableDescriptionShowInTitle,
        expandedInfos,
        displayMode,
        appNameLower,
    ]);
    return (React__namespace.createElement(mosaic.Provider, null,
        React__namespace.createElement(JSVOptionsContextProvider, { value: options },
            React__namespace.createElement(jotai.Provider, null,
                React__namespace.createElement(JsonSchemaViewerInner, Object.assign({ viewMode: viewMode, skipTopLevelDescription: skipTopLevelDescription, isMergeAllOf: isMergeAllOf }, rest))))));
};
const JsonSchemaViewerInner = ({ schema, viewMode, className, resolveRef, emptyText = 'No schema defined', onTreePopulated, maxHeight, parentCrumbs, skipTopLevelDescription, showSelectorCombiners, isMergeAllOf, }) => {
    const { jsonSchemaTreeRoot, nodeCount } = React__namespace.useMemo(() => {
        const jsonSchemaTree$1 = new jsonSchemaTree.SchemaTree(schema, {
            mergeAllOf: isMergeAllOf !== null && isMergeAllOf !== void 0 ? isMergeAllOf : false,
            refResolver: resolveRef,
            additionalPropertiesKey: ADDITIONAL_PROPERTIES_KEY,
        });
        let nodeCount = 0;
        const shouldNodeBeIncluded = (node) => {
            if (!jsonSchemaTree.isRegularNode(node))
                return true;
            const { validations } = node;
            if (!!validations.writeOnly === !!validations.readOnly) {
                return true;
            }
            return !((viewMode === 'read' && !!validations.writeOnly) || (viewMode === 'write' && !!validations.readOnly));
        };
        const processedRefs = {};
        jsonSchemaTree$1.walker.hookInto('filter', (node) => {
            var _a, _b, _c;
            if (shouldNodeBeIncluded(node)) {
                if ((_a = node === null || node === void 0 ? void 0 : node.originalFragment) === null || _a === void 0 ? void 0 : _a.$ref) {
                    const parentRefs = processedRefs[(_b = node === null || node === void 0 ? void 0 : node.parent) === null || _b === void 0 ? void 0 : _b.id] || [];
                    if (parentRefs.filter(res => { var _a; return res === ((_a = node === null || node === void 0 ? void 0 : node.originalFragment) === null || _a === void 0 ? void 0 : _a.$ref); }).length > 1) {
                        return false;
                    }
                    else {
                        processedRefs[node.id] = [...parentRefs, (_c = node === null || node === void 0 ? void 0 : node.originalFragment) === null || _c === void 0 ? void 0 : _c.$ref];
                    }
                }
                nodeCount++;
                return true;
            }
            return false;
        });
        jsonSchemaTree$1.populate();
        return {
            jsonSchemaTreeRoot: jsonSchemaTree$1.root,
            nodeCount,
        };
    }, [schema, isMergeAllOf, resolveRef, viewMode]);
    React__namespace.useEffect(() => {
        onTreePopulated === null || onTreePopulated === void 0 ? void 0 : onTreePopulated({
            rootNode: jsonSchemaTreeRoot,
            nodeCount: nodeCount,
        });
    }, [jsonSchemaTreeRoot, onTreePopulated, nodeCount]);
    const isEmpty = React__namespace.useMemo(() => jsonSchemaTreeRoot.children.every(node => !jsonSchemaTree.isRegularNode(node) || node.unknown), [jsonSchemaTreeRoot]);
    if (isEmpty) {
        return (React__namespace.createElement(mosaic.Box, { className: classNames__default['default'](className, 'JsonSchemaViewer') }, emptyText));
    }
    return (React__namespace.createElement(mosaic.Box, { className: classNames__default['default']('JsonSchemaViewer', className), pos: maxHeight ? 'relative' : undefined, overflowY: maxHeight ? 'auto' : undefined, style: { maxHeight } },
        React__namespace.createElement(PathCrumbs, { parentCrumbs: parentCrumbs }),
        React__namespace.createElement(TopLevelSchemaRow, { schemaNode: jsonSchemaTreeRoot.children[0], skipDescription: skipTopLevelDescription, showSelectorCombiners: showSelectorCombiners })));
};
const JsonSchemaFallbackComponent = ({ error }) => {
    return (React__namespace.createElement(mosaic.Box, { p: 4 },
        React__namespace.createElement(mosaic.Box, { as: "b", color: "danger" }, "Error"),
        error !== null ? `: ${error.message}` : null));
};
const JsonSchemaViewerContent = reactErrorBoundary.withErrorBoundary(JsonSchemaViewerComponent, {
    FallbackComponent: JsonSchemaFallbackComponent,
    recoverableProps: ['schema'],
});
const JsonSchemaViewer = (props) => {
    const { locale, messages } = getLocaleInfo(props === null || props === void 0 ? void 0 : props.locale);
    return (React__namespace.createElement("div", { className: classNames__default['default']('app-json-schema-viewer', styles$1['schema-viewer']) },
        React__namespace.createElement(reactIntl.IntlProvider, { locale: locale, messages: messages },
            React__namespace.createElement(JsonSchemaViewerContent, Object.assign({}, props)))));
};

exports.JsonSchemaViewer = JsonSchemaViewer;
exports.Validations = Validations;
//# sourceMappingURL=index.js.map
